// 数据上报key值
// https://docs.qq.com/sheet/BYeyFa0J8NYX4wVI1f2dm7HZ18QPLK0Rx8si1?tab=BB08J2&coord=A1%24A1%240%240%240%240

// slide数据上报文档 https://doc.weixin.qq.com/sheet/e3_m_eubkTyFvQqVg

/* ===================================  TDW operation id  ============================== */
export const TDWOperationType = {
    DOC_PPT: 'doc_ppt', // PPT-PC端编辑
    DOC_MENUBAR: 'doc_menubar', // new header
    DOC_ADDON_PLATFORM: 'doc_addon_platform', // 插件平台
    DOC_FORMULA: 'doc_formula', // 插入Latex公式
    DOC_PERFORMANCE: 'ppt_performance', // performance性能相关
    PAGING_SELECTION: 'paging_selection', // 分页导入
    DOC_INSERT_TDOC: 'insert_tdoc', // 插入腾讯文档
    DOC_ALL: 'doc_all', // 无障碍
    PPT_ANIMATION: 'ppt_animation', // 动画
    PLUG_IN: 'plug_in', // 智能工具第三方插件
    DOC_MEET_WEB: 'doc_meet_web', // 文档&会议联动
    DOC_WORD_EDITOR: 'doc_word_editor', // 统一的上报oper，附件上传用
    DOC_ADDON: 'doc_addon', // 插件商城
    DETAIL_PAGE: 'detail_page', // 详情页

    // b 端
    DOC_EDITOR_TOPBAR_PC: 'doc_editor_topbar_pc', // 详情页顶部栏

    // 质量相关
    PPT_QUALITY: 'quality_slide', // 质量相关
    OCR: 'OCR', // ocr组件相关
    OCR_COMPONENTS: 'ocr_components', // ocr组件相关（新产品riki）
    VIP_UPGRADE: 'doc_vip_upgrade', // 开通vip相关

    // 商业化
    DOC_VIP_ALLFUNC: 'doc_vip_allfunc',
    DOC_TEMPLATE_WEB: 'doc_template_web', // 模板商城模板
    DOC_VIP_SLIDEQUICKTOOL: 'doc_vip_slidequicktool',
    DOC_VIP: 'doc_vip_detail',

    // AI
    DOC_PPT_AI: 'doc_ppt_ai',
    PRINT_PPT: 'print_ppt',
    // 加密文件夹
    SAFE_FOLDER: 'doc_vip_safefolder',
    DOC_VIP_EDITOR: 'doc_vip_editor',
};

/* ===================================  TDW module id  ================================= */
export const TDWModuleType = {
    PC_OBJ: 'pc_obj', // PC对象编辑
    PC_EDIT_INSERT: 'pc_edit_insert', // PC编辑能力-插入
    PC_EDIT_FORMAT: 'pc_edit_format', // PC编辑能力-格式设置
    PC_EDIT_LIST: 'pc_edit_list', // PC编辑能力-编辑正文-幻灯片列表
    PC_EDIT: 'pc_edit',
    PC_PLAY: 'pc_play', // PPT-PC端编辑
    PC_LOCAL_PLAY: 'local_play', // PC本地播放
    PC_PLAY_PRESENTER: 'presenter', // 播放(本地&远程)-演讲者模式
    PC_EDIT_PAGE: 'pc_edit_page', // 编辑能力-页面设置
    PC_EDIT_ANIMATION: 'pc_edit_animation', // 编辑能力-动画设置
    PC_SIDE_BAR: 'sidebar', // 侧边栏
    M_MORE_MENU: 'mob_menu', // 移动端更多菜单
    M_EDIT_MODE: 'mob_edit', // 移动端编辑态
    M_VIEW_MODE: 'mob_view', // 移动端查看态
    M_PIC_EDIT: 'pic_edit', // 移动端图片操作
    M_SHAPE_EDIT: 'shape_edit', // 移动端形状操作
    M_EXCEL_EDIT: 'excel_edit', // 移动端表格操作
    M_VIEW_TOOLBAR: 'view_toolbar', // 移动端的顶部栏
    M_GENERAL_EDIT: 'general_edit', // 移动端的常规操作
    M_EDIT_FORMAT: 'mobile_edit_format', // 移动端编辑能力-格式设置
    PC_FUNCTION: 'pc_function', // PPT-PC端编辑
    PC_TABLE_FORMAT: 'excel_format', // 表格格式
    PC_TEXT_FORMAT: 'text_format', // PPT-文本格式编辑
    PC_TEXT_SET: 'text_set',
    PC_EDIT_ALIGN: 'ppt_pc_edit_align', // PPT-文本格式设置
    PPT_PC_EDIT_COMBINATION: 'ppt_pc_edit_combination', // PC组合操作
    PC_SEARCH: 'pc_search', // PC-查找替换
    PC_RE_SHOW: 're_show', // PC远程播放/会议
    PC: 'pc', // PC端编辑
    AI_TOOLBAR: 'toolbar', // PC端编辑
    AI_TITLEBAR: 'titlebar', // PC端编辑
    M_MOBILE_BUTTON: 'mobile_button', // 移动端按钮
    FILE_BUTTON: 'file_button', // 菜单文件按钮点击
    MORE_BUTTON: 'more_button', // 菜单更多按钮点击
    PC_EDIT_PROFORMAT_PA: 'pc_edit_proformat_panel', // 高级样式面板点击 (工具栏 浮动工具栏)
    PC_EDIT_PROFORMAT: 'pc_edit_proformat', // 右侧边栏面板点击
    PC_TOOLBAR: 'toolbar', // 顶部菜单栏
    TOOLBAR_MODE: 'toolbar_mode', // 切换工具栏模式
    THIRD_SERVICES: 'third_services', // 第三方内容
    ADDON_INSERT_TOOLBAR: 'insert_toolbar', // 第三方内容工具栏
    ADDON_IFRAME: 'iframe', // 插件
    PC_TOOLBAR_INSERT: 'toolbar-insert', // 工具栏-插入
    PC_TOOLBAR_PIC: 'toolbar-pic', // 工具栏-图片
    PC_TOOLBAR_FORM: 'toolbar-form', // 工具栏-表格
    PASTE_SPECIAL: 'paste_special', // 选择性粘贴
    COPY_PASTE: 'copy_paste', // 选择性粘贴
    ANIMATION_BATCH: 'animation_batch', // 批量动画-指令点击

    // Latex公式
    FORMULA_TOOLBAR: 'toolbar', // 顶部菜单栏
    FORMULA_NEW: 'new', // 新建公式
    FORMULA_RE_EDITED: 're_edited', // 再次编辑文档公式
    FORMULA_RE_EDITED_IMPORT: 're_edited_import', // 再次编辑引入的公式

    // 插入腾讯文档
    TDOC_SELECTOR: 'file_selector', // 腾讯文档选择器

    // Performance
    PERFORMANCE_DETAIL: 'detail', // 详情页

    SLIDE_UPLOAD: 'slide_upload', // 导入
    SLIDE_PREVIEW: 'slide_preview', // 导入预览
    DOC_ACCESSIBILITY: 'doc_accessibility', // 无障碍

    DRAG_FILE: 'drag_file', // 拖动文件
    INSERT_SLIDE: 'insert_slide', // 插入幻灯片
    INSERT_SLIDE_ENTRY: 'insert_slide_entry', // 插入幻灯片 - 分页导入
    TIME_NODE: 'time_node', // 动画节点

    GUIDES: 'guides', // 参考线
    TEXT_RULER: 'ruler', // 标尺
    GRID_LINE: 'gridline', // 网格线
    GRID_LINE_SETTING: 'gridline_setting', // 网格面板

    // 临时：for 智能工具-第三方插件
    SMART: 'smart', // 工具栏入口
    PPT: 'ppt', //

    // 文档&会议联动
    SHARE_IN_MEET: 'share_in_meet', // 会议中共享文档
    DOC_TO_MEET: 'doc_to_meet', // 文档发起会议

    // 附件上传
    LOCAL_FILES: 'local_files',
    INDENT: 'toolbar', // 设置缩进
    EXPORT: 'export',

    // 侧边栏上报
    SIDEBAR: 'sidebar',
    SIDEBAR_STYLE_FILL: 'sidebar-style-fill', // 填充
    SIDEBAR_STYLE_BORDER: 'sidebar-style-border',
    SIDEBAR_STYLE_SHADOW: 'sidebar-style-shadow',
    SIDEBAR_STYLE_GLOW: 'sidebar-style-glow', // 映像
    SIDEBAR_STYLE_LUMINE: 'sidebar-style-lumine', // 发光
    SIDEBAR_STYLE_SOFTEN: 'sidebar-style-soften', // 柔化边缘
    SIDEBAR_STYLE_TRANS: 'sidebar-style-trans', // 全局透明度
    SIDEBAR_TEXT_FONT: 'sidebar-text-font',
    SIDEBAR_TEXT_PARAGRAPH: 'sidebar-text-paragraph',
    SIDEBAR_TEXT_BOX: 'sidebar-text-box',
    SIDEBAR_LAYOUT_ALIGN: 'sidebar-layout-align',
    SIDEBAR_LAYOUT_LEVEL: 'sidebar-layout-level',
    SIDEBAR_LAYOUT_GROUP: 'sidebar-layout-group',
    SIDEBAR_LAYOUT_SIZE: 'sidebar-layout-size',
    SIDEBAR_LAYOUT_ROTATE: 'sidebar-layout-rotate',
    SIDEBAR_LAYOUT_3D: 'sidebar-layout-3d', // 三维属性
    SIDEBAR_TABLE_BORDER: 'sidebar-table-border',
    SIDEBAR_PICTURE_EDIT: 'sidebar-picture-edit', // 图片编辑
    SIDEBAR_PICTURE_CORRECTION: 'sidebar-picture-correction', // 图片校正
    SIDEBAR_PICTURE_EFFECT: 'sidebar-picture-effect', // 图片效果
    SIDEBAR_BACKGROUND: 'sidebar-background',
    SIDEBAR_LAYOUT_POS: 'sidebar-layout-pos', // 布局-位置
    SIDEBAR_FONT_FILL: 'sidebar-text-fill', // 文本填充
    SIDEBAR_FONT_SHADOW: 'sidebar-text-shadow', // 文本阴影
    SIDEBAR_FONT_GLOW: 'sidebar-text-glow', // 文本映像
    SIDEBAR_FONT_LUMINE: 'sidebar-text-lumine', // 文本发光
    SIDEBAR_FONT_BORDER: 'sidebar-text-border', // 文本边框

    // b 端
    MORE_MENU: 'more_menu', // 更多按钮

    // 插件商城
    ADDON_LIST: 'addon_list',

    // 一键换色
    COLOR_SWITCH: 'color_switch',

    // 美化
    BEAUTIFY_TAB: 'beautify_tab',

    // 表格
    TABLE_STYLE_TAB: 'table_style_tab',
    TABLE_LAYOUT_TAB: 'table_layout_tab',

    // 排版检查
    AUTO_BEAUTIFY: 'auto_beautify',

    // 模板商城模板
    TEMPLATE_MALL: 'template_mall',
    TEMPLATE_ITEM: 'template_item',

    ADD_PAGE: 'add_page',
    // canvas渲染层
    CANVAS_RENDERER: 'canvas_renderer', // canvas版本的渲染层相关
    OCR_PICTURE: 'doc_picture', // ocr识别图片
    EXTRACT_TEXT: 'extract_text', // ocr提取图片文字

    // 生成图片
    EXPORT_IMAGE: 'export_image', // 生成图片

    // 动画面板
    SIDEBAR_ANIME: 'sidebar_anime',

    // 选择窗格
    SELECT_PANEL: 'select_panel',

    // note
    SLIDE_PC_NOTE: 'slide_pc_note',
    SLIDE_MOBILE_NOTE: 'slide_mobile_note',
    PARAGRAPH_PANEL: 'paragraph_panel', // 段落格式面板

    // 母版
    MASTER: 'master',

    // 节
    SECTION: 'section',

    // 图表
    CHART: 'chart',
    CHART_TOOLBAR: 'chart_toolbar',
    RIGHT_FORMAT_PANEL: 'right_format_panel',

    // 项目符号编辑面板
    BULLETS_AND_NUMBERING_DIALOG: 'bulleted_numbering_panel',

    // 更多模板
    MORE_TEMPLATES: 'more_templates',

    POPUP: 'popup',
    LINK_TEXT: 'linktext',

    // 商业化
    ENTRANCE: 'entrance',
    TOPDF: 'topdf',

    // 新色盘
    COLOR_MODULE: 'color_palette',

    // 本地编辑
    LOCAL_DOC_EDIT: 'local_doc_edit',
    LOCAL_DOC_VIEW: 'local_doc_view',
    LOCAL_DOC: 'local_doc',

    // 云编
    DRIVE_DOC_EDIT: 'drive_doc_edit',
    DRIVE_DOC_VIEW: 'drive_doc_view',
    DRIVE_DOC: 'drive_doc',

    // 页面通用
    HTML_DOCUMENT: 'html_document',

    // 性能
    PERFORMANCE: 'slide_performance', // 性能上报（新）
    PERFORMANCE_START: 'start',

    // 不知道是啥
    FUNCTION: 'function',

    // trace
    TRACE: 'trace',

    // 手机遥控器
    MOBILE_CONTROLLER: 'mobile_controller',
    // 新工具栏
    S_MENU: 's_menu', // 工具栏 单栏菜单
    TOOLBAR_INSERT_TAB: 'toolbar_insert_tab', // 工具栏 插入tab
    TOOLBAR_EFFICIENT_TAB: 'toolbar_efficient_tab', // 工具栏 效率工具tab
    TOOLBAR_PLAY_TAB: 'toolbar_play_tab', // 工具栏 放映tab
    ANIMATION_TAB: 'animation_tab', // 工具栏 动画tab
    START_TAB: 'start_tab', // 工具栏 开始tab
    TOOLBAR_VIEW_TAB: 'toolbar_view_tab', // 工具栏 视图tab
    TOOL_TAB: 'tool_tab',
    TOOLBAR_REVIEW_TAB: 'toolbar_review_tab', // 工具栏 批注tab
    IMG_PREVIEW: 'img_preview', // 图片预览

    // AI 助手
    CREATE_PPT: 'creat_ppt', // 生成PPT
    SWITCH_TEMPLATE: 'switch_template', // 切换模版
    CREAT_NOTE: 'creat_note', // 生成演讲备注
    SWITCH_FONT: 'switch_font', // 字体切换
    SWITCH_COLOR: 'switch_color', // 配色切换
    PAGE_BEAUTY: 'page_beauty', // 单页美化
    // AI titlebar 入口
    TITLE_BAR_ENTRANCE: 'titlebar_entrance', // 顶部栏入口
    MOBILE_ENTRANCE: 'mobile_entrance', // 移动端入口
    WRITE_NOTE: 'write_note', // AI 写备注
    READ: 'read', // AI 阅读
    FULL_REVIEW: 'full_review', // AI 全文审阅
    PAGE_CREATE: 'page_create', // AI 生成页
    AI_WRITE: 'text_create', // AI写作
    LAYOUT_CHECK: 'layout_check', // 排版检查
    TEMPLATE_SWITCH: 'template_switch', // 模版切换
    FONT_SWITCH: 'font_switch', // 字体切换
    // 打印
    MOBILE: 'mobile',
    PC_TITLEBAR: 'pctitlebar',
    PC_MORE: 'pcmore',
    SHORTCUT: 'shortcut',
    // 加密文件夹
    DISABLE_TIPS: 'disable_tips',
    // 批注
    COMMENTS_SLIDEBAR: 'comments_slidebar',
    // 视频附件
    VIDEO_ATTACHMENT: 'video_attachment',
    RIGHT_MENU: 'rightmenu',

    // 密码弹框
    PASSWORD_POPUP: 'password_popup',
};

/* ===================================  TDW action id  ================================= */
export const TDWActionType = {
    CLICK: 'click', // 点击
    // 形状
    CLK_EDIT: 'clk_edit', // 点击形状进入编辑态
    EDIT_TEXT_WORD: 'edit_text_word', // 形状编辑文字
    EDIT_SIZE: 'edit_size', // 形状调整大小
    SHAPE_MOVE: 'shape_move', // 形状移动
    SHAPE_WHIRL: 'shape_whirl', // 形状旋转

    // 图片
    CLK_IMG: 'clk-img', // 点击图片进入编辑态
    IMG_CUT: 'img_cut', // 图片裁剪
    IMG_SIZE: 'img_size', // 图片调整大小
    IMG_MOVE: 'img_move', // 图片移动
    IMG_WHIRL: 'img_whirl', // 图片旋转
    IMG_RESTORE: 'img_restore', // 图片恢复初始态

    // 图片插入
    MENU_IMG: 'menu_img', // 菜单插入-上传本地图片插入
    TOOL_IMAGE: 'tool_image', // 工具栏-上传本地图片插入
    PASTEP_IMG: 'pastep_img', // 粘贴板插入图片
    PICTURES: 'pictures', // 工具栏-插入图片

    // 音频插入
    AUDIO: 'audio', // 工具栏-插入音频

    // 视频插入
    VIDEO: 'video', // 工具栏-插入视频

    // 组合
    CLK_COMBIN: 'clk_combin', // 点击组合进入编辑态
    EDIT_SHAPE: 'edit_shape', // 编辑组合中形状
    EDIT_IMG: 'edit_img', // 编辑组合中图片
    EDIT_FORM: 'edit_form',
    EDIT_TEXT: 'edit_text', // 编辑组合中文本框
    EDIT_SHAP_TEXT: 'edit_shap_text', // 编辑组合中形状文字

    // 图形插入
    CLK_TOOL_SHAPE: 'clk_tool_shape', // 工具栏-插入图形按钮点击
    CLK_SHAPE: 'clk_shape', // 插入图形面板具体图形点击
    CLK_MENU_SHAPE: 'clk_menu_shape', // 菜单插入-插入图形按钮点击
    SHAPES: 'shapes', // 工具栏-插入图形

    // 图片
    CROP: 'crop', // 图片-裁切
    CROP_MENU: 'crop_menu', // 图片-裁切-菜单
    TRANSPARENCY: 'transparency', // 图片-透明度

    // 格式刷
    FORMAT_PAINTER: 'format_painter', // 工具栏-格式刷
    CLEAR_FORMATTING: 'clear_formatting', // 清除格式

    // 文本框插入
    CLK_TOOL_TEXT: 'clk_tool_text', // 工具栏-插入文本框点击
    CLK_MENU_TEXT: 'clk_menu_text', // 菜单插入-插入文本框点击
    CLK_TWO_TEXT: 'clk_two_text', // 编辑区双击插入文本框
    TEXT_BOX: 'text_box', // 工具栏-插入文本框

    // 表格
    CLK_MENU_TABLE: 'menu_form', // 菜单栏-插入表格点击
    CLK_TOOL_TABLE: 'tool_form', // 工具栏-插入表格点击
    TABLE_DELETE: 'delete', // 删除表格
    TABLE_MOVE: 'remove', // 移动表格
    TABLE_BORDER_STYLE: 'edge', // 设置边线线型号
    TABLE_BORDER_COLOR: 'colour', // 设置边线颜色
    TABLE_INSERT_ROW: 'insert', // 插入行
    TABLE_DELETE_ROW: 'delete_row', // 删除行
    TABLE_INSERT_COLUMN: 'insert_column', // 插入列
    TABLE_DELETE_COLUMN: 'delete_column', // 删除列
    FORM: 'table', // 表格
    BORDERS: 'borders', // 边框线
    MERGE_FORM: 'merge', // 合并单元格

    // 添加页面
    ADD_SUC: 'add_suc', // 幻灯片列表-直接添加页面成功
    CLK_TEMPLATE: 'clk_template', // 幻灯片列表-添加页面选择版式按钮点击
    ADD_TEM_SUC: 'add_tem_suc', // 幻灯片列表-选择模板添加页面成功

    // 表格样式tab
    TABLE_TAB_STYLE_HEADER_ROW: 'header_row',
    TABLE_TAB_STYLE_FIRST_COLUMN: 'first_column',
    TABLE_TAB_STYLE_BANDED_ROW: 'banded_row',
    TABLE_TAB_STYLE_TOTAL_ROW: 'total_row',
    TABLE_TAB_STYLE_LAST_COLUMN: 'last_column',
    TABLE_TAB_STYLE_BANDED_COLUMN: 'banded_column',
    TABLE_TAB_STYLE_QUICK_STYLE: 'quick_style',
    TABLE_TAB_STYLE_MERGE: 'merge',
    TABLE_TAB_STYLE_SPLIT: 'split',
    TABLE_TAB_STYLE_BORDER_TYPE: 'border_type',
    TABLE_TAB_STYLE_BORDER_WEIGHT: 'border_weight',

    // 表格布局
    TABLE_TAB_STYLE_DELETE: 'delete',
    TABLE_TAB_LAYOUT_INSERT_ABOVE: 'insert_above',
    TABLE_TAB_LAYOUT_INSERT_BELOW: 'insert_below',
    TABLE_TAB_LAYOUT_INSERT_LEFT: 'insert_left',
    TABLE_TAB_LAYOUT_INSERT_RIGHT: 'insert_right',
    TABLE_TAB_LAYOUT_ROW_SIZE: 'row_size',
    TABLE_TAB_LAYOUT_COLUMN_SIZE: 'column_size',
    TABLE_TAB_LAYOUT_DISRTIBUTE_ROWS: 'disrtibute_rows',
    TABLE_TAB_LAYOUT_DISTRIBUTE_COLUMNS: 'distribute_columns',
    TABLE_TAB_LAYOUT_CELL_MARGINS: 'cell_margins',
    TABLE_TAB_LAYOUT_TEXT_DIRECTION: 'text_direction',


    // 本地播放
    CLK: 'clk', // 工具栏-本地播放按钮点击
    HOT_KEY: 'hot_key', // 本地播放快捷键
    RIGHT_CLICK: 'right_click', // 鼠标右键-进入播放
    INTERFACE: 'interface', // 成功进入播放界面
    PLY: 'ply', // 本地演示工具栏-发起远程演示
    DROP: 'drop', // 本地演示工具栏-退出演示
    OPEN: 'open', // 本地演示工具栏-开启激光笔；无障碍开关打开
    SHUT: 'shut', // 本地演示工具栏-关闭激光笔

    // 页面设置
    THISPAGE_FT: 'thispage_ft', // 当前页面为4:3
    THISPAGE_SN: 'thispage_sn', // 当前页面为16:9
    THISPAGE_OTH: 'thispage_oth', // 当前页面为其他比例
    CHANGE_FT: 'change_ft', // 切换为4:3
    CHANGE_SN: 'change_sn', // 切换为16:9

    // 工具栏边框填充
    TEXT_STUFF: 'text_stuff', // 文本框-填充设置,弹出工具栏色板菜单就上报
    TEXT_FRAME: 'text_frame', // 文本框-边框设置
    SHAPE_STUFF: 'shape_stuff', // 形状-填充设置
    SHAPE_FRAME: 'shape_frame', // 形状-边框设置
    IMG_STUFF: 'img_stuff', // 图片-填充设置
    IMG_FRAME: 'img_frame', // 图片-边框设置
    FORM_STUFF: 'form_stuff', // 表格-填充设置
    FORM_FRAME: 'form_frame', // 表格-边框设置

    FAST_STUFF_TEXT: 'fast_stuff_text', // 文本框-填充快速设置
    FAST_FRAME_TEXT: 'fast_frame_text', // 文本框-边框快速设置
    FAST_STUFF_SHAPE: 'fast_stuff_shape', // 形状-填充快速设置
    FAST_FRAME_SHAPE: 'fast_frame_shape', // 形状-边框快速设置
    FAST_STUFF_IMG: 'fast_stuff_img', // 图片-填充快速设置
    FAST_FRAME_IMG: 'fast_frame_img', // 图片-边框快速设置
    FAST_STUFF_FORM: 'fast_stuff_form', // 表格-填充快速设置
    FAST_FRAME_FROM: 'fast_frame_from', // 表格-边框快速设置

    CLK_NOSTUFF: 'clk_nostuff', // 无填充点击
    CLK_COLOR: 'clk_color', // 填充色盘点击
    CLK_COLORLAST: 'clk_colorlast', // 填充最近颜色点击
    CLK_SELF_COLOR: 'clk_self_color', // 填充自定义颜色点击
    CLK_CHANGE_COLOR: 'clk_change_color', // 渐变填充点击
    CLK_STUFF_IMG: 'clk_stuff_img', // 图片填充点击
    STUFF_MORE: 'stuff_more', // 填充更多样式设置
    IMG_TRANSPARENT: 'img_transparent', // 图片透明度设置

    CLK_NOFRAME: 'clk_noframe', // 无边框点击
    CLK_FCOLOR: 'clk_fcolor', // 边框色盘点击
    CLK_FCOLORLAST: 'clk_fcolorlast', // 边框最近颜色点击
    CLK_FSELF_COLOR: 'clk_fself_color', // 边框自定义颜色点击
    CLK_FRAME_THICK: 'clk_frame_thick', // 边框线条粗细点击
    CLK_FRAME_TYPE: 'clk_frame_type', // 边框线条类型点击
    FRAME_MORE: 'frame_more', // 线条更多样式设置
    CLK_ARROW: 'clk_arrow', // 边框箭头样式点击

    // CLK_SHADOW_TYPE: 'clk_shadow_type',   // 阴影样式点击, confirm later

    BACK_THISPAGE: 'back_thispage', // 背景设置应用到当前页
    BACK_ALLPAGE: 'back_allpage', // 背景设置应用到所有页面
    BACK_RESET: 'back_reset', // 背景设置重置背景

    SHAPE_UPV: 'shape_upv', // 形状格式侧边栏打开人数、次数
    PIC_UPV: 'pic_upv', // 图片格式侧边栏打开人数、次数
    BACKGROUD_UPV: 'backgroud_upv', // 背景格式侧边栏打开人数、次数

    TEXT_FONT: 'font', // 字体设置
    TEXT_SIZE: 'size', // 字号设置
    TEXT_BOLD: 'bold', // 加粗设置
    TEXT_ITALIC: 'tilt', // 加粗设置
    TEXT_UNDERLINE: 'underline', // 下划线设置
    TEXT_DELETE: 'delete', // 加粗设置
    TEXT_COLOR: 'colour', // 字体颜色设置
    TEXT_HIGHLIGHT: 'play', // 字体背景色设置（别问我key为什么这么奇怪）
    ITALIC: 'italic', // 斜体设置
    STRIKE_THROUGH: 'strikethrough', // 删除线设置
    SUBSCRIPT: 'subscript', // 下标
    SUPERSCRIPT: 'superscript', // 上标设置
    TEXT_HIGHLINE: 'highline', // 高亮设置

    BULLET_LIBRARY: 'bulleted_library', // PPT桌面端-工具栏-项目符号
    NUMBER_LIBRARY: 'numbering_library', // PPT桌面端-工具栏-数字编号
    TEXT_CHARACTER_BULLET: 'bullet', // 项目符号
    TEXT_CHARACTER_NUMBER: 'number', // 数字符号
    TEXT_HORIONTAL_ALIGN: 'right', // 水平对齐
    TEXT_VERTICAL_ALIGN: 'vertical', // 垂直对齐
    TEXT_LINE_HEIGHT: 'line_space', // 行高
    HORIZONTAL: 'horizontal_align', // PPT桌面端-工具栏-水平对齐
    LINE_SPACING: 'line_spacing', // 行间距
    VERTICAL_ALIGN: 'vertical_align', // 垂直对齐
    ARRANGE: 'arrange', // 元素对齐
    GROUP: 'group', // 组合
    FILL_COLOR: 'fill_color', // 填充色
    OUTLINE_COLOR: 'outline-color', // 边框颜色
    OUTLINE_WEIGHT: 'outline-weight', // 边框重量
    OUTLINE_TYPE: 'outline-type', // 边框类型
    ANIMATION: 'animations', // 动画
    BACKGROUND: 'background', // 背景
    SLIDE_SIZE: 'slide_size', // 尺寸设置
    FIND: 'find', // 查找

    ANIME_TOOLBAR: 'anime_toolbar', // 动画点击

    // 快捷设置
    TEXT_POP_UP: 'pop_up', // 文本框-快接浮层弹出
    TEXT_FILLING: 'filling', // 文本框-快接浮层-填充点击
    TEXT_FRAME2: 'frame', // 文本框-快接浮层-边框点击
    TEXT_LEVEL_ADJUST: 'level_adjust', // 文本框-快接浮层-层级调整点击

    FONT_POP_UP: 'fast', // 文字-快捷浮层弹出
    FONT_FORMAT_BRUSH: 'format_brush', // 文字-快捷浮层-格式刷
    FONT_TEXT_FONT: 'text_font', // 文字-快捷浮层-字体加大减小
    FONT_FONT_SIZE: 'font_size', // 文字-快捷浮层-字号设置
    FONT_FONT_BOLD: 'font_bold', // 文字-快捷浮层-加粗设置
    FONT_SIZE_INCREASE: 'font_size_increase', // PPT桌面端-工具栏-快捷增大字号
    FONT_SIZE_DECREASE: 'font_size_decrease', // PPT桌面端-工具栏-快捷减小字号

    SHAPE_POP_UP: 'shape_pop_up', // 形状-快接浮层弹出
    SHAPE_FILLING_CLICK: 'filling_click', // 形状-快接浮层-填充点击
    SHAPE_FRAME_CLIK: 'frame_clik', // 形状-快接浮层-边框点击
    SHAPE_LEVEL: 'shape_level', // 形状-快接浮层-层级调整点击

    PIC_POP_UP: 'pic_pop_up', // 图片-快接浮层弹出
    PIC_CROP: 'crop', // 图片-快接浮层-裁剪点击
    PIC_FRAME: 'pic_frame', // 图片-快接浮层-边框点击
    PIC_LEVEL_ADJUST: 'pic_level_adjust', // 图片-快接浮层-层级调整点击

    EXL_POP_UP: 'exl_pop_up', // 表格-快接浮层弹出
    EXL_FRAME: 'exl_frame', // 表格-快接浮层-边框点击
    EXL_LEVEL_ADJUST: 'exl_level_adjust', // 表格-快接浮层-层级调整点击

    COLOR_PICKER: 'color_picker', // 取色器

    // 选择性粘贴
    DESTINATION_THEME: 'destination_theme', // 使用目标主题
    SOURCE_FORMAT: 'source_format', // 保留源格式
    SHAPE_EXPOSURE: 'shape_exposure', // 粘贴形状图标曝光埋点
    SLIDE_EXPOSURE: 'slide_exposure', // 粘贴幻灯片图标曝光埋点

    // 复制粘贴
    COMMON_COPY: 'common_copy', // 通用复制（读取数据并写入剪切板）

    // 动画
    ANIME_INSERT: 'anime_insert', // PPT成功插入进入动画
    ANIME_REMOVE: 'anime_remove', // PPT成功删除进入动画
    ANIME_INSERT_STRESS: 'anime_insert_stress', // PPT成功插入强调动画
    ANIME_REMOVE_STRESS: 'anime_remove_stress', // PPT成功删除强调动画
    ANIME_INSERT_QUIT: 'anime_insert_quit', // PPT成功插入退出动画
    ANIME_REMOVE_QUIT: 'anime_remove_quit', // PPT成功删除退出动画
    PLAY_ANIME: 'play_anime', // PPT播放有动画
    ENTER_ANIME: 'enter_anime', // PPT播放有进入动画
    STRESS_ANIME: 'stress_anime', // PPT播放有强调动画
    QUIT_ANIME: 'quit_anime', // PPT播放有退出动画
    MOVE_ANIMATION: 'move_animation', // 移动动画
    TOOLBAR_ANIM_CLICK: 'toolbar_anim_click', // 点击工具栏动画图标
    MODIFY_ANIM: 'modify_anim', // 修改动画
    DELETE_ANIM: 'delete_anim', // 删除动画
    ANIM_PERFORMANCE: 'anim_performance', // 动画性能
    ANIM_REACT: 'anim_react', // 动画点击后的响应/切页后的响应
    ANIM_BRUSH: 'anim_brush', // 动画刷
    BATCH: 'batch', // 批量动画-入口点击
    ADD: 'add', // 批量动画-批量添加动画
    ADD_SUCCESS: 'add_success', // 批量动画-添加成功
    DELETE_MORE: 'delete_more', // 批量动画-更多删除选项
    DELETE_MORE_SUCCESS: 'delete_more_success', // 批量动画-更多删除选项-删除成功
    ORDER_CLK: 'order_clk', // 批量动画-指令点击
    CANCEL: 'cancel', // 批量动画-取消添加
    SUCCESS: 'success', // 批量动画-添加成功

    // 新动画面板
    ADD_ANIME: 'add_anime',
    DELETE_ANIME: 'delete_anime',
    PLAY_ALL: 'play_all',
    DRAG: 'drag',
    SWITCH_ANIME: 'switch_anime', // 调整动画类型
    SET_START_WAY: 'set_start_way',
    SET_DIRECTION: 'set_direction',
    SET_DELAY: 'set_delay',
    SET_DURATION: 'set_duration',
    SET_TIRGGER: 'set_tirgger',
    SET_PROPERTY: 'set_property',
    CORNER_MARK_HIDDON: 'corner_mark_hiddon',

    // 对齐
    ALIGN_QUICK_TOTAL: 'total_uv', // PC对齐操作-总用户

    ALIGN_QUICK_RIGHT: 'quick_right', // PC对齐操作-快捷操作-左/右/上/下对齐
    ALIGN_QUICK_MID: 'quick_mid', // PC对齐操作-快捷操作-垂直/水平居中对齐
    ALIGN_QUICK_VERTICAL: 'quick_vertical', // PC对齐操作-快捷操作-垂直/水平分散对齐

    ALIGN_TOOL_RIGHT: 'tool_right', // PC对齐操作-工具栏操作-左/右/上/下对齐
    ALIGN_TOOL_MID: 'tool_mid', // PC对齐操作-工具栏操作-垂直/水平居中对齐
    ALIGN_TOOL_VERTICAL: 'tool_vertical', // PC对齐操作-工具栏操作-垂直/水平分散对齐

    ALIGN_MENU_RIGHT: 'menu_right', // PC对齐操作-菜单栏操作-左/右/上/下对齐
    ALIGN_MENU_MID: 'menu_mid', // PC对齐操作-菜单栏操作-垂直/水平居中对齐
    ALIGN_MENU_VERTICAL: 'menu_vertical', // PC对齐操作-菜单栏操作-垂直/水平分散对齐

    ALIGN_CLICK_RIGHT: 'click_right', // PC对齐操作-右键菜单操作-左/右/上/下对齐
    ALIGN_CLICK_MID: 'click_mid', // PC对齐操作-右键菜单操作-垂直/水平居中对齐
    ALIGN_CLICK_VERTICAL: 'click_vertical', // PC对齐操作-右键菜单操作-垂直/水平分散对齐

    // 组合
    COMBINATION_TOTAL_UV: 'total_uv', // PC组合操作-总用户
    REMOVE_COMBINATION_TOTAL_UV: 'oper_total_uv', // PC解除组合操作-总用户
    COMBINATION_TOOL: 'tool', // PC组合操作-工具栏
    REMOVE_COMBINATION_TOOL: 'combine_tool', // PC解除组合操作-工具栏
    COMBINATION_MENU: 'menu', // PC组合操作-菜单栏
    REMOVE_COMBINATION_COM_MENU: 'com_menu', // PC解除组合操作-菜单栏
    COMBINATION_CLICK: 'click', // PC组合操作-鼠标右键
    REMOVE_COMBINATION_COM_CLICK: 'com_click', // PC解除组合操作-鼠标右键

    // 会议
    PC_RESHOW_OPEN_MEETING: 'open_meeting', // PC-远程演示主端打开会议
    PC_RESHOW_STOP_MEETING: 'stop_meeting', // PC-远程演示主端关闭会议
    PC_RESHOW_MUTE_ALL: 'mute_all', // PC-远程演示主端会议全部静音
    PC_RESHOW_BAN_SOMEONE: 'ban_someone', // PC-远程演示主端会议禁言某人
    PC_RESHOW_MUTE_SELF: 'mute_self', // PC-远程演示主端会议静音自己
    PC_RESHOW_JOIN_MEETING: 'join_meeting', // PC-远程演示收看端成功加入会议
    PC_RESHOW_QUIT_MEETING: 'quit_meeting', // PC-远程演示收看端成功退出会议
    PC_RESHOW_WATCH: 'watch', // PC-远程演示收看端会议静音自己

    // 查找替换
    PC_SEARCH_SIDE_BAR: 'sidebar',
    PC_SEARCH_LAST: 'last',
    PC_SEARCH_NEXT: 'next',
    PC_SEARCH_REP_SIDE_BAR: 'rep_sidebar',
    PC_SEARCH_REP_LAST: 'rep_last',
    PC_SEARCH_REP_NEXT: 'rep_next',
    PC_SEARCH_REP_RESULT: 'rep_result',
    PC_SEARCH_REP_ALL: 'rep_all',
    PC_SEARCH_REP_ALL_SUC: 'rep_all_suc',

    // 插入第三方内容
    ADDON_INSERT: 'insert',
    ADDON_COPY: 'copy',
    ADDON_MODIFY: 'modify',
    ADDON_DELETE: 'delete',
    ADDON_REFRESH: 'refresh',
    ADDON_FULL_SCREEN: 'full_screen',
    ADDON_OPEN: 'original_page',
    ADDON_INSERT_STYLE: 'insert_style',

    // 主题切换
    THEME_VIEW: 'view',
    THEME_CLICK: 'clk',
    THEME_SUCCESS: 'success',

    // 美化
    BEAUTIFY_SWITCH_TEMPLATE: 'switch_template',
    BEAUTIFY_SWITCH_COLOR: 'switch_color',
    BEAUTIFY_MORE_COLOR: 'more_color',
    BEAUTIFY_CUSTOM_COLOR: 'custom_color',
    BEAUTIFY_UNIFY_FONT: 'unify_font',
    BEAUTIFY_PIC_ADJUST: 'pic_adjust',
    BEAUTIFY_PIC_ADJUST_FUNCTION: 'pic_adjust_function',
    BEAUTIFY_SLIDE_SIZE: 'slide_size',
    BEAUTIFY_SLIDE_SIZE_SELECT: 'slide_size_select',
    BEAUTIFY_SLIDE_CUSTOM_SIZE: 'slide_custom_size',
    BEAUTIFY_BACKGROUND: 'background',
    BEAUTIFY_MASTER: 'master',
    BEAUTIFY_MORE_TEMPLATE: 'more_template',

    // 排版检查
    BEAUTIFY_AUTO_BEAUTIFY_CLK: 'auto_beautify_clk', // 排版检查
    BEAUTIFY_FUNCTION_VIEW: 'function_view', // 面板曝光
    BEAUTIFY_SUCCESS: 'success', // 评分成功
    BEAUTIFY_TITLE_SIZE: 'title_size', // 标题字号处理
    BEAUTIFY_SUBTITLE_SIZA: 'subtitle_siza', // 副标题字号处理
    BEAUTIFY_LINE_SPACE: 'line_space', // 行间距处理
    BEAUTIFY_FONT_QUANTITY: 'font_quantity', // 字体数量处理
    BEAUTIFY_TEXT_OVERLAP: 'text_overlap', // 文字重叠处理
    BEAUTIFY_CONTRAST: 'contrast', // 对比度处理
    BEAUTIFY_TITLE_ALIGNMENT_VIEW: 'title_alignment_view', // 标题对齐处理弹窗
    BEAUTIFY_TITLE_ALIGNMENT_SUCCESS: 'title_alignment_success', // 标题对齐处理成功
    BEAUTIFY_M_VIEW: 'm_view', // 移动端入口曝光
    BEAUTIFY_M_CLICK: 'm_clk', // 移动端入口点击
    BEAUTIFY_VIEW_TO_EDIT: 'view_to_edit', // 移动端预览页点击去优化跳转到编辑页

    // 插件商城
    LIST_VIEW: 'list_view', // 点击toolbar的插件按钮
    CLK_ADDON: 'clk_addon', // 点击具体插件
    GET_ADDON: 'get_addon', // 获取更多
    MANAGE_ADDON: 'manage_addon', // 管理插件

    UNDO: 'undo', // 撤销
    REDO: 'redo', // 重做

    // 插入腾讯文档
    TDOC: 'tdocs', // 工具栏插入腾讯文档
    INSERT_TDOC_ENTER_CLK: 'enter_clk',
    INSERT_TDOC_INSERT_SUCCEED: 'insert_clk',

    // 侧边栏上报
    SWITCH: 'switch',
    UNFOLD_ITEM: 'unfold_item',
    FOLD_ITEM: 'fold_item',
    SHORTCUT: 'shortcut',
    SET: 'set',
    SOLID_COLOR: 'solid-color',
    SOLID_CUSTOM_COLOR: 'solid-custom-color',
    GRADIENT_TYPE: 'gradient-type',
    GRADIENT_ANGLE: 'gradient-angle',
    GRADIENT_POS: 'gradient-pos',
    GRADIENT_ADD_COLOR: 'gradient-add-color',
    GRADIENT_DE_COLOR: 'gradient-de-color',
    GRADIENT_RE_COLOR: 'gradient-re-color',
    GRADIENT_EDIT_COLOR: 'gradient-edit-color',
    GRADIENT_ROTATE: 'gradient-rotate',
    PIC_UPLOAD: 'pic-upload',
    PIC_PASTE: 'pic-paste',
    PIC_TYPE: 'pic-type',
    PIC_TRANS: 'pic-trans',
    PIC_ROTATE: 'pic-rotate',
    TYPE: 'type',
    SOLID_TYPE: 'solid-type',
    SOLID_SIZE: 'solid-size',
    POINT: 'point',
    SIZE: 'size',
    BLUR: 'blur',
    DISTANCE: 'distance',
    TRANS: 'trans',
    ANGLE: 'angle',
    COLOR: 'color',
    CUSTOM_COLOR: 'custom-color',
    FONT: 'font',
    INCREASE_SIZE: 'increase-size',
    DECREASE_SIZE: 'decrease-size',
    HIGHLIGHT: 'highlight',
    BOLD: 'bold',
    UNDERLINE: 'underline',
    STRIKE: 'strike',
    H_ALIGN: 'h-align',
    V_ALIGN: 'v-align',
    BULLETS: 'bullets',
    NUMBERING: 'numbering',
    AUTO_ADJUST: 'auto-adjust',
    DIRECTION: 'direction',
    PADDING: 'padding',
    AUTO_WRAP: 'auto-wrap',
    DISTRIBUTE: 'distribute',
    ALL: 'all',
    ADJUST: 'adjust',
    LOCK_RATE: 'lock-rate',
    RESET: 'reset',
    CLARITY: 'clarity',
    BRIGHTNESS: 'brightness',
    CONTRAST: 'contrast',
    SATURATION: 'saturation',
    TEMPERATURE: 'temperature',
    APPLY_ALL: 'apply-all',
    APPLY: 'apply',
    ROTATE: 'rotate',
    SOLID_TRANS: 'solid-trans', // 纯色填充透明度
    GRADIENT_TRANS: 'gradient-trans', // 渐变填充透明度
    ZOOM: 'zoom',
    POS: 'pos', // 布局-位置
    PIC_RESIZE: 'pic_resize', // 布局-缩放大小
    PIC_SIZE_ORIGINAL: 'pic_size_original', // 布局-相对于图片原始尺寸

    // 新色盘
    COLOR_PICKER_ACTION: 'color',

    /*
     ** 移动端上报
     */

    // 移动端更多菜单
    M_SHARE_CLICK: 'clk', // 更多菜单-分享点击
    M_AUTHORITY_CLICK: 'click', // 更多菜单-权限点击
    M_AUTHORITY_APPLY_CLICK: 'apply', // 更多菜单-权限申请点击
    M_DULPLICATE: 'copy', // 更多菜单-生成副本
    M_OUTPUT_AS_PPT: 'save_ppt', // 更多菜单-导出为PPT文档
    M_RENAME: 'rename', // 更多菜单-重命名
    M_RECORD: 'record', // 更多菜单-查看浏览记录
    M_HELP: 'help', // 更多菜单-帮助反馈

    // 移动端编辑态
    M_ENTER_EDIT: 'pv', // 移动端编辑态-页面进入次数
    M_IMG_INSERT: 'img_insert', // 移动端编辑态-图片插入
    M_FINISH_EIDT: 'over', // 移动端编辑态-完成编辑
    M_EDIT_MOVE: 'move', // 移动端编辑态-移动
    M_EDIT_ROTATE: 'rotate', // 移动端编辑态-旋转
    M_EDIT_DELETE: 'delete', // 移动端编辑态-删除
    M_EDIT_EDIT: 'edit', // 移动端编辑态-编辑文字
    M_EDIT_BOLD: 'font_bold', // 移动端编辑态-加粗
    M_EDIT_ITALIC: 'font_tilt', // 移动端编辑态-斜体
    M_EDIT_UNDERLINE: 'font_underline', // 移动端编辑态-下划线
    M_EDIT_DELETELINE: 'font_delete', // 移动端编辑态-删除线
    M_EDIT_FONTSIZE: 'font_size', // 移动端编辑态-字体加减
    M_EDIT_FORECOLOR: 'font_color', // 移动端编辑态-字色
    M_EDIT_HORIZONTAL_ALIGN: 'align', // 移动端编辑态-对齐
    M_EDIT_ITEMNUMBER: 'bullet', // 移动端编辑态-项目符号
    M_EDIT_DIGITNUMBER: 'number', // 移动端编辑态-数字编号

    // 移动端查看态
    M_TOOLBAR_PLAY: 'play', // 查看态-工具栏-播放按钮
    M_TOOLBAR_EDIT: 'edit', // 查看态-工具栏-编辑按钮
    M_TOOLBAR_SHARE: 'share_button', // 查看态-工具栏-分享按钮

    // 移动端常规操作
    M_GENERAL_UNDO: 'cancel', // 撤销
    M_GENERAL_REDO: 'redo', // 重做
    // 移动端备注
    M_REMARKS_VISIT_ON: 'visit_open', // 查看态-备注栏开启
    M_REMARKS_VISIT_OFF: 'visit_close', // 查看态-备注栏关闭
    M_REMARKS_EDIT_ON: 'edit_open', // 编辑态-备注栏开启
    M_REMARKS_EDIT_OFF: 'edit_close', // 编辑态-备注栏关闭

    // PC端编辑 视图
    // ENTER_FULL: 'enter_full',                            // 进入全屏模式
    // QUIT_FULL: 'quit_full',                              // 退出全屏模式
    AMP: 'amp', // 状态栏放大文档
    REDUCE: 'reduce', // 状态栏缩小文档
    ADAPT: 'adapt', // 状态栏自适应屏幕

    // player性能打点
    PLAYER_ENTER: 'player_enter',
    PLAYER_SWITCH: 'player_switch',
    PLAYER_ANIM_FPS: 'anim_avg_fps',

    // 链接
    LINK: 'link', // 工具栏插入链接
    LINK_INSERT: 'link_insert', // PPT成功插入链接
    LINK_EDIT: 'link_modify', // PPT成功修改链接

    // new header
    MENU_BAR_CLICK: 'click',

    MORE_EFFECT_SETTING: 'more_clk', // 更多“效果”设置
    OPEN_TOOLBAR_EFFECT: 'open', // 打开“效果”设置工具栏
    SHADOW_CLK: 'shadow_clk', // 阴影设置成功
    GLOW_CLK: 'shine_clk', // 发光设置成功
    REFELECTION_CLK: 'reflection_clk', // 倒影设置成功
    SOFTEDGE_CLK: 'smooth_clk', // 边缘柔化设置成功
    NO_CLK: 'no_clk', // 清除效果设置成功
    STYLE: 'style', // 效果设置

    // 远程演示
    REMOTESHOW_IFRAMELOAD: 'remoteshow_ifremaeload', // 远程演示，观众页面，加载 Player iFrame
    REMOTESHOW_ENTERROOM: 'remoteshow_enterroom', // 远程演示，观众页面，加载 Player iFrame

    // Latex公式
    LATEX: 'latex', // 工具栏插入latex公式
    FORMULA_CLICK: 'click', // 点击操作
    FORMULA_INSERT: 'insert', // 插入行为

    // Performance
    PERFORMANCE_ELEMENT_INFO: 'element_info', // 元素信息统计
    PERFORMANCE_DATA_ERROR: 'performance_data_error', // 接口异常分析
    PERFORMANCE_HARDWARE_ACCELERATED: 'hardware_accelerated', // 硬件加速信息
    PERFORMANCE_WEBGL_SUPPORTED: 'webgl_supported', // webgl支持
    SIZE_WIDTH_HEIGHT_LARGER_THAN_300CM: 'size-width-height-larger-than-300cm', // 宽度或高度大于300cm
    SLIDE_LIST_CHANGE: 'slide-list-change', // 左侧可见的缩略图的变化时上报

    // 分页上传相关
    GET_SECRET_KEY: 'get_secret_key', // 获取密钥
    UPLOAD_SINGLE_CHUNK: 'upload_single_chunk', // 上传分片
    UPLOAD_SUCCESS: 'upload_success', // 上传成功
    UPLOAD_CANCEL: 'upload_cancel', // 上传取消
    START_PASE_SLIDE: 'start_prase_slide', // 开始解析
    GET_SLIDE_TEXT: 'get_slide_text', // 获取解析后的 atext
    RIGHT_CLICK_IMPORT: 'right_click_import', // 右键点击导入
    DRAG_IMPORT: 'drag_import', // 拖拽导入
    CANCEL_INSERT: 'cancel_insert', // 取消插入幻灯片
    CONFIRM_INSERT: 'confirm_insert', // 确认插入幻灯片

    // 拖动文件相关
    DRAG_FILE_NEW: 'new', // 拖拽文件 - 新建导入
    DRAG_FILE_INSERT: 'insert', // 拖拽文件 - 选页导入
    INSERT_SLIDE_CANCEL: 'cancel', // 分页导入模态框 - 取消
    INSERT_SLIDE_SUC: 'suc', // 分页导入模态框 - 确定导入
    INSERT_SLIDE_ENTRY_CLICK: 'click', // 左侧列表右键 - 点击
    INSERT_SLIDE_ENTRY_LOCAL: 'local', // 左侧列表右键 - 选择本地文件点击
    INSERT_SLIDE_ENTRY_ONLINE: 'online', // 左侧列表右键 - 选择在线文件点击

    // 参考线
    ADD_VERTICAL_GUIDE: 'add_vertical_guide', // 添加垂直参考线
    ADD_HORIZONTAL_GUIDE: 'add_horizontal_guide', // 添加水平参考线
    GUIDES_COLOR: 'color', // 参考线颜色
    GUIDES_DELETE: 'delete', // 删除参考线

    // 标尺
    OPEN_TEXT_RULER: 'open_click', // 点击标尺菜单
    EXPOSURE_TEXT_RULER: 'exposure', // 标尺打开

    // 网格
    OPEN_GRID_LINE: 'open_click', // 点击网格菜单
    EXPOSURE_GRID_LINE: 'exposure', // 网格打开
    OPEN_GRID_LINE_DIALOG: 'click', // 点击网格面板菜单

    // 第三方内容
    ADDON: 'addon', // 插入第三方内容

    // 模板商城
    TEMP_LATE_UPV: 'temp_late_upv', // 缩略图曝光
    TEMPLATE_CLICK: 'template_clk', // 模板点击使用
    TEMPLATE_MALL_PAGE_VIEW: 'page_view', // 模板商城页面曝光

    // 无障碍
    CLOSE: 'close', // 无障碍开关关闭
    INTERACTIVE_CLICK: 'interactive_click', // 触发器点击
    MAIN_CLICK: 'main_click', // 常规动画点击

    // 临时：for 智能工具-第三方插件
    TOOL: 'tool', // 工具栏入口点击
    ISLIDE: 'islide', // iSlide 插件点击

    // 文档&会议联动
    BEGIN_PRESENTATION: 'begin_presentation', // 成功共享文档
    BEGIN_PRESENTATION_CLK: 'begin_presentation_clk', // 「用腾讯会议演示」按钮点击时上报
    BEGIN_PRESENTATION_SET: 'begin_presentation_set', // 成功调起会议时上报
    AUDIENCE: 'audience', // 观看者pv

    // 附件上传
    UPLOAD_CLICK: 'upload_click', // 点击本地上传入口
    DOWNLOAD_CLICK: 'download_click', // 点击附件下载按钮
    TOOLBAR_DELETE: 'toolbar_delete', // 点击附件删除按钮
    FILE_SHOW: 'file_show', // 附件露出
    FILE_GROUP_SHOW: 'file_group_show', // 组合附件露出

    // 设置缩进
    INDENT: 'indent',
    DEC_INDENT: 'dec_indent',
    ENTRANCE_CLICK: 'entrance_click', // 导出为本地文档
    LOCAL_DOC_ADD_ZIP: 'local_doc_add_zip', // 导出形式（确认）
    LOCAL_DOC_ONLY: 'local_doc_only', // 导出形式（仅本地文档）
    POPUP_CLOSE: 'popup_close', // 关闭弹框（取消/关闭）
    TOAST_CANCEL: 'toast_cancel', // 取消导出

    // 演讲者视图
    START_PRESENTER: 'start', // 进入演讲者视图
    POINTER_PRESENTER: 'pointer', // 激光笔点击
    IN_FONT_SIZE_PRESENTER: 'in_font_size', // 增大字体点击
    DE_FONT_SIZE_PRESENTER: 'de_font_size', // 缩小字体点击
    EXIT_PRESENTER: 'exit', // 退出演讲者模式按钮点击
    // 本地演示
    VIEW_START_PRESENTER: 'view_start', // 顶部工具栏演讲者(备注)视图入口曝光
    CLK_START_PRESENTER: 'clk_start', // 顶部工具栏演讲者(备注)视图入口点击
    VIEW_POPUP_PRESENTER: 'view_popup', // 播放器工具栏演讲者(备注)视图入口曝光
    CLICK_POPUP_PRESENTER: 'click_popup', // 播放器工具栏演讲者(备注)视图入口点击
    // 远程演示
    VIEW_SWITCH_PRESENTER: 'view_switch', // 切换视图按钮曝光
    CLICK_SWITCH_PRESENTER: 'click_switch', // 切换视图按钮点击

    // workbench
    TOOLBAR_OPEN: 'open', // 工具栏面板展开
    TOOLBAR_CHANGE: 'change', // 工具栏切换
    // b 端
    VEIW: 'veiw', // 菜单曝光
    VIEW: 'view', // 菜单曝光
    ADD_TO_QUICK_ACCESS: 'add_to_quickaccess', // 快速访问
    FAVORITE: 'favorite', // 收藏
    PERMISSION: 'permission', // 权限管理
    GET_LINK: 'get_link', // 获取分享链接
    REVISION_HISTORY: 'revision_history', // 查看修订记录
    BROWSING_HISTORY: 'browsing_history', // 查看浏览记录
    GENERATE_COPY: 'generate_copy', // 生成副本
    SAVE_AS_TEMPLATE: 'save_as_template', // 另存为我的模板
    EXPORT: 'export', // 导出
    SCREEN_READING: 'screen_reading', // 无障碍读屏
    EXIT_DOCUMENT: 'exit_document', // 退出文档

    // try-catch保护的质量相关上报
    CANVAS_RENDERER_BUILD_TREE: 'canvas_renderer_build_tree', // 构建渲染树
    COMPONENT_FACTORY_RENDER: 'component_factory_render', // 元素组件渲染更新
    OCR_ENTRANCE: 'entrance', // ocr图片识别入口

    EXPORT_OPEN: 'export_open', // 生成图片打开
    EXPORT_CLOSE: 'export_close', // 生成图片关闭

    // 新选择窗格
    SELECT_OPEN: 'open',
    SHOW_ALL: 'show_all',
    HIDE_ALL: 'hide_all',
    HIDE_ONE: 'hide_one',
    SHOW_ONE: 'show_one',
    UNFOLD_GROUP: 'unfold_group',
    FOLD_GROUP: 'fold_group',
    SELECT_DRAG: 'drag',
    SET_WIDTH: 'set_width',

    // js error上报
    SLIDE_JS_ERROR_NORMAL: 'js_error',
    SLIDE_JS_ERROR_PROMISE: 'js_error_promise',
    SLIDE_JS_ERROR_COLLECTION: 'js_error_collection',
    STACK_TRACE: 'stack_trace',

    // 统计备注数据
    SLIDE_NOTE_SIZE: 'slide_note_size',
    SLIDE_NOTE_MOBILE_ENTER_EDITING: 'slide_note_mobile_enter_editing',

    // 段落格式面板
    SET_ALIGNMENT: 'set_alignment',
    SET_INDENTATION: 'set_indentation',
    SET_SPACING: 'set_spacing',
    TABS_CLK: 'tabs_clk',
    ADD_TAB: 'add_tab',
    DELETE_TAB: 'delete_tab',

    // 母版
    MASTER_VIEW: 'view',
    MASTER_CLICK: 'clk',
    MASTER_RENAME: 'rename',
    MASTER_TITLE_CHECKBOX_CLICK: 'title_clk',
    MASTER_TEXT_CHECKBOX_CLICK: 'text_clk',
    MASTER_DATE_CHECKBOX_CLICK: 'date_clk',
    MASTER_FOOTER_CHECKBOX_CLICK: 'footer_clk',
    MASTER_PAGE_NUM_CHECKBOX_CLICK: 'page_num_clk',
    SET_THEME_FONT: 'set_font',
    SWITCH_LAYOUT: 'switch_layout',
    INSERT_LAYOUT: 'insert_layout',
    INSERT_PLACEHOLDER: 'insert_placeholder',
    THUMB_COPY: 'thumb_copy',
    THUMB_CUT: 'thumb_cut',
    THUMB_PASTE: 'thumb_paste',
    THUMB_INSERT_LAYOUT: 'thumb_insert_layout',
    THUMB_COPY_LAYOUT: 'thumb_copy_layout',
    THUMB_DELETE_LAYOUT: 'thumb_delete_layout',
    THUMB_OPEN_SIDEBAR: 'thumb_open_sidebar',

    // 节
    ADD_SECTION: 'add_section',
    MODIFY_SECTION: 'modify_section',
    DELETE_SECTION: 'delete_section',
    MOVE_SECTION: 'move_section',

    // 图表
    INSERT_CHART: 'insert_chart',
    CHART_RIGHT_BAR_DISPALY: 'right_format_panel', // 侧边栏展示
    CHART_ELEMENT: 'chart_element', // 图表元素点击
    OPEN_CHART_EDIT_PANEL: 'open_data_modal',
    CHART_EDITED: 'edit_data_modal',
    MODIFY_CHART_TYPE: 'modify_chart_type',

    RENDER_FALLBACK: 'render_fallback', // 渲染兜底图
    RENDER_CHART: 'render_chart', // 渲染图表
    AXIS_CALCULATE_ERROR: 'axisCalculateError', // 坐标轴计算错误
    AXIS_TICKS_CALCULATE_ERROR: 'axisTicksCalculateError', // 坐标轴ticks计算错误

    SVG_FOREIGN_OBJECT: 'svg-foreign-object',

    // 项目符号编辑面板
    BULLETS_AND_NUMBERING_DIALOG_TYPE: 'bulleted_numbering_type',
    BULLETS_AND_NUMBERING_DIALOG_OPEN_SOURCE: 'bulleted_numbering_library',
    BULLETS_AND_NUMBERING_DIALOG_COLOR: 'bulleted_numbering_color',
    BULLETS_AND_NUMBERING_DIALOG_SIZE: 'bulleted_numbering_size',
    BULLETS_AND_NUMBERING_DIALOG_CUSTOM_CONTENT: 'bulleted_custom_content',
    BULLETS_AND_NUMBERING_DIALOG_START_NUMBER: 'numbering_start_number',

    // 更多模板
    MORE_TEMPLATES_CLICK: 'click',
    MORE_TEMPLATES_PLUG_IN: 'plug_in',

    SHOW: 'show',
    // 快捷美化相关
    SHORTCUT_TOOL: 'shortcut_tool',
    SHORTCUT_TOOL_UNIFORM_FONT_CLICK: 'shortcut_tool_uniform_font_click',
    SHORTCUT_TOOL_REPLACE_FONT_CLICK: 'shortcut_tool_replace_font_click',
    SHORTCUT_TOOL_IMAGE_SIZE_CLICK: 'shortcut_tool_image_size_click',
    SHORTCUT_TOOL_IMAGE_LAYOUT_CLICK: 'shortcut_tool_image_layout_click',
    SHORTCUT_TOOL_IMAGE_DOWNLOAD_CLICK: 'shortcut_tool_image_download_click',
    SHORTCUT_TOOL_UNIFORM_FONT_OK: 'shortcut_tool_uniform_font_ok',
    SHORTCUT_TOOL_REPLACE_FONT_OK: 'shortcut_tool_replace_font_ok',
    SHORTCUT_TOOL_IMAGE_SIZE_OK: 'shortcut_tool_image_size_ok',
    SHORTCUT_TOOL_IMAGE_LAYOUT_OK: 'shortcut_tool_image_layout_ok',
    SHORTCUT_TOOL_IMAGE_DOWNLOAD_OK: 'shortcut_tool_image_download_ok',

    // 三维属性
    DEPTH_3D: 'depth',
    DEPTH_COLOR_3D: 'depth-color',
    ROTATION_PRESET_3D: 'rotation-preset',
    ROTATION_X_3D: 'rotation-x',
    ROTATION_Y_3D: 'rotation-y',
    ROTATION_Z_3D: 'rotation-z',
    FLAT_TEXT_3D: 'flat-text',
    LIGHT_TYPE_3D: 'light-type',
    LIGHT_ROTATION_3D: 'light-rotation',
    MATERIAL_TYPE_3D: 'material-type',
    RESET_3D: 'reset',

    // 本地编辑/云编
    DOC_EDIT_SAVE: 'save',
    DOC_ENTER_EDIT: 'edit',
    DOC_VIEW_BOX_CLICK: 'box_click',
    DOC_VIEW_MENU_CLICK: 'menu_click',
    DOC_VIEW_LIST_CLICK: 'list_click',
    DOC_VIEW: 'view',

    // 页面非正常偏移
    HTML_ABNORMAL_OFFSET: 'HTML-abnormal-offset',

    // 点击工具栏分栏按钮
    TOOLBAR_COLUMNS_CLICK: 'columns_click',
    // 工具栏分栏下拉框选项点击
    COLUMNS_NUMBER: 'columns_number',
    // 分栏弹窗更多设置
    MORE_COLUMNS: 'more_columns',

    // 性能
    TTI: 'tti', // 首页露出时的性能数据采集
    LIST_LOAD: 'list_load', // 列表各页渲染完成的性能数据采集
    // 文档关键帧损坏
    BROKEN_DOC: 'broken_doc',
    // 文档关键帧损坏，无法打开，用户通过弹窗导出
    EXPORT_BROKEN_DOC: 'export_broken_doc',
    // 编辑过程中出现数据异常
    DATA_ERROR: 'data_error',
    // 编辑过程中出现数据异常，用户通过弹窗导出
    EXPORT_DATA_ERROR: 'export_data_error',

    // 手机遥控器入口曝光
    MOBILE_CONTROLLER_FUNCTION_VIEW: 'function_view',
    // 手机遥控器入口点击
    MOBILE_CONTROLLER_FUNCTION_CLK: 'function_clk',
    // 手机遥控器专业工具栏入口点击
    MOBILE_CONTROLLER_DOUBLE_TOOLBAR_FUNCTION_CLK: 'double_toolbar_function_clk',
    // 手机遥控器配对成功
    MOBILE_CONTROLLER_PAIR_SUCCESS: 'pair_success',
    // 手机遥控器上一页
    MOBILE_CONTROLLER_NEXT_PAGE: 'next_page',
    // 手机遥控器下一页
    MOBILE_CONTROLLER_PREVIOUS_PAGE: 'previous_page',
    // 手机遥控器文字大小
    MOBILE_CONTROLLER_NOTE_SIZE: 'note_size',
    // 手机遥控器结束播放
    MOBILE_CONTROLLER_STOP_PLAY: 'stop_play',
    // 手机遥控器错误页，账号不一致
    MOBILE_CONTROLLER_INCONSISTENT_ACCOUNT: 'insistent_account',
    // 手机遥控器开始计时
    MOBILE_CONTROLLER_START_TIMER: 'start_timer',
    // 手机遥控器暂停计时
    MOBILE_CONTROLLER_PAUSE_TIMER: 'pause_timer',
    // 手机遥控器计时中重置计时
    MOBILE_CONTROLLER_RESET_TIMER_ON_START: 'reset_timer_on_start',
    // 手机遥控器暂停计时中重置计时
    MOBILE_CONTROLLER_RESET_TIMER_ON_PAUSE: 'reset_timer_on_pause',
    // 加载文档
    LOAD_DOC: 'load_doc',

    PAGE: 'page', // 空白页面
    TEMPLATE: 'template', // 模版页面
    TABLE: 'table', // 表格
    CHART: 'chart', // 图表
    FOOTER: 'footer', // 页脚
    TDOCS: 'tdocs', // 腾讯文档
    FILES: 'files', // 本地文件
    SANITIZE: 'sanitize', // 数据脱敏
    DOWNLOAD_PIC: 'download_pic', // 图片下载
    CONVERT_PDF: 'convert_pdf', // pdf转换
    CREATE_PIC: 'create_pic', // 生成图片
    addon: 'addon', // 插件
    BEGIN: 'begin', // 从头演示
    CURRENT: 'current', // 从当前页演示
    NOTE_VIEW: 'note_view', // 备注视图
    REMOTE: 'remote', // 远程演示
    TMEETING: 'tmeeting', // 腾讯会议演示

    // 工具栏-视图Tab
    NORMAL: 'normal',
    MASTER: 'master',
    RULER: 'ruler',
    GUIDES: 'guides',
    GRIDLINE: 'gridline',
    SNAP_LINE: 'snap_line',
    NOTE: 'note',
    AUTO_ZOOM: 'auto_zoom',

    AI_CLK: 'clk',
    AI_START: 'start',
    AI_SUCCESS: 'success',
    AI_FAIL: 'fail',
    AI_MORE: 'more',
    AI_VIEW: 'view',
    AI_DELETE: 'delete',
    AI_INSERT: 'insert',
    AI_OUTLINE_SUCCESS: 'outline_success',

    PRINT_ENTRANCE_CLICK: 'entranceclick',

    // 批注
    ADD_COMMENTS: 'add_comments',
    DELETE_COMMENTS: 'delete_comments',
    DELETE_PAGE_COMMENTS: 'delete_page_comments',
    DELETE_ALL_COMMENTS: 'delete_all_comments',
    LAST_COMMENTS: 'last_comments',
    NEXT_COMMENTS: 'next_comments',
    VIEW_COMMENTS: 'view_comments',
    SHOW_COMMENTS_MARKS: 'show_comments_marks',
    NEW_COMMENTS_REMIND: 'new_comments_remind',
    MARK_CLK: 'mark_clk',
    REMIND_VIEW: 'remind_view',
    REMIND_CLK: 'remind_clk',
    ADD_COMMENTS_SUCCESS: 'add_comments_success',
    LAST_COMMENT: 'last_comment',
    NEXT_COMMENT: 'next_comment',
    REPLY: 'reply',
    EDIT_CMMENTS: 'edit_cmments',
    EDIT_REPLY: 'edit_reply',
    DELETE_REPLY: 'delete_reply',

    // 本地文档转多人在线
    LOCAL_TO_ONLINE_BY_IMPORT: 'local_to_online_by_import',
    LOCAL_TO_ONLINE_BY_COLLABORATE: 'local_to_online_by_collaborate',

    // 渲染内存相关
    RENDER_TREE_LIMIT: 'render_tree_limit',
    // 拉端
    OPEN_CLIENT: 'open_client',

    // 视频附件
    INSERT_VIDEO: 'insert_video',
    INSERT_VIDEO_SUCCESS: 'insert_video_success',
    PLAY_VIDEO: 'play_video',
    AUTO_TRANSCODE: 'auto_transcode',
    IMAGE_JOINT_HOVER: 'imagejoint_hover',
    IMAGE_JOINT_CLICK: 'imagejoint_click',

    // 密码弹框
    PASSWORD_SHOW: 'show',
    PASSWORD_CLICK: 'click',

    // add page action
    MORE_CLICK: 'more_click',
    MORE_TEMPLATE: 'more_template',
    MORE_FORMAT: 'more_format',
    MORE_AI: 'more_ai',
};

/* ===================================  TDW ver3 id  =================================== */
export const TDWVer3Type = {
    SINGLE_TOOLBAR: '1',
    DOUBLE_TOOLBAR: '2',
    RIGHT_MENU: '3',
};

/* ===================================  TDW ver4 id  =================================== */
export const TDWVer4Type = {
    TOOLBAR_NORMAL_DISPLAY: '1',
    TOOLBAR_WRAP_DISPLAY: '2',
};

/* ===================================  TDW ver5 id  =================================== */
export const TDWVer5Type = {
    // b 端
    ENABLE: 'enable', // 开启
    DISABLE: 'disable', // 关闭

    // c端
    DOC_DETAIL_TOOLBAR: 'doc_detail_toolbar', // 插件商城
    MOBILE_TOOLBAR_OCR: 4,

    // 商业化
    VIP_USER: 'vip_user',
    SVIP_USER: 'svip_user',
    SVIP_PLUS: 'svip_plus',
    NOVIP_USER: 'novip_user',

    // 色盘
    COLOR_PICKER_BORDER: 1,
    COLOR_PICKER_SHADOW: 2,
    COLOR_PICKER_GLOW: 3,
    COLOR_PICKER_LUMINE: 4,
    COLOR_PICKER_SOFTEN: 5,
    COLOR_PICKER_FORE_FONT: 6,
    COLOR_PICKER_BACK_FONT: 7,
    COLOR_PICKER_FILL: 8,
    COLOR_PICKER_BULLETS: 9,

    // 主题
    TOOLBAR_SOURCE: 1,
    RIGHT_MENU_SOURCE: 2,
};

/* ===================================  TDW ver6 id  =================================== */
export const TDWVer6Type = {
    PDF: 'pdf',
    SLIDE2PDF: 'slide2pdf',

    // 色盘点击来源
    COLOR_PICKER_DRAWER: 1, // 侧边栏
    COLOR_PICKER_TOOLBAR: 2, // 工具栏
    COLOR_PICKER_FLOAT: 3, // 浮动工具栏
    COLOR_PICKER_TITLE: 4, // 顶栏
    M_COLOR_PICKER_TOOLBAR: 5, // 移动端工具栏
};

/* ===================================  TDW ver8 id  =================================== */
export const TDWVer8Type = {
    FROM_TEXT: 1, // 1-从文本打开
    FROM_SHAPE: 2, // 2-此图形打开
    FROM_IMAGE: 3, // 3-从图片打开
    FROM_VIDEO: 4, // 4-从视频打开
    FROM_TABLE: 5, // 5-从表格打开
    FROM_ADDON: 6, // 6-从插件打开
    FROM_ATTACHMENT: 7, // 7-从附件打开
    FROM_CONNECTOR: 8, // 8-从线条打开
    FROM_SLIDE: 9, // 9-从背景打开
    FROM_GROUP: 10, // 10-从组合打开
    FROM_MULTIPLY: 99, // 99-多选元素
};

export const TDWVer9Type = {
    DETAIL_IFRAME_TOOLBAR: 'doc_detail_iframe_toolbar',
    DETAIL_PIC_TOOLBAR: 'doc_detail_pic_toolbar',
    DETAIL_IFRAME_RIGHT_CLK: 'doc_detail_iframe_right_clk',
    DETAIL_PIC_RIGHT_CLK: 'doc_detail_pic_right_clk',
    DETAIL_TXT_RIGHT_CLK: 'doc_detail_txt_right_clk',
    DETAIL_INSERT: 'doc_detail_insert',
    TOOLBAR: 'toolbar',
};

export const TDWVer10Type = {
    NEW_MENUBAR: 'new_menubar', // 新菜单上报标识
    OLD_MENUBAR: 'old_menubar', // 老菜单上报标识
};

export const TDWVer11Type = {
    OPEN: 1, // 打开
    CLOSE: 2, // 关闭
    PC_SLIDETOOLBAR: 'pc_slidetoolbar',
};

/* ===================================  TDW file_type  =================================== */
export const TDWFileType = {
    SLIDE: 'slide',
    DOC: 'doc',
    PDF: 'pdf',
    TOOLBAR_SLIDE: 4,
};

/* ===================================  event code Report  =================================== */
export const EventCodeType = {
    WORKBENCH_TOGGLE_OPEN_EVENT_OPEN: 'doc_word_editor-toolbar_mode-open',
    WORKBENCH_TOGGLE_OPEN_EVENT_CHANGE: 'doc_word_editor-toolbar_mode-change',
    WORKBENCH_TOGGLE_OPEN: 'doc_word_editor-toolbar-open',
    DOC_ADDON_ADDON_LIST_LIST_VIEW: 'doc_addon-addon_list-list_view',
    DOC_ADDON_ADDON_LIST_CLK_ADDON: 'doc_addon-addon_list-clk_addon',
    DOC_ADDON_ADDON_LIST_GET_ADDON: 'doc_addon-addon_list-get_addon',
    DOC_ADDON_ADDON_LIST_MANAGE_ADDON: 'doc_addon-addon_list-manage_addon',
    // 侧边栏
    DOC_PPT_SIDEBAR_OPEN: 'doc_ppt-sidebar-open',
    DOC_PPT_SIDEBAR_SWITCH: 'doc_ppt-sidebar-switch',
    DOC_PPT_SIDEBAR_UNFOLD_ITEM: 'doc_ppt-sidebar-unfold_item',
    DOC_PPT_SIDEBAR_FOLD_ITEM: 'doc_ppt-sidebar-fold_item',
    DOC_PPT_SIDEBAR_STYLE_FILL_SHORTCUT: 'doc_ppt-sidebar-style-fill-shortcut',
    DOC_PPT_SIDEBAR_STYLE_FILL_SET: 'doc_ppt-sidebar-style-fill-set',
    DOC_PPT_SIDEBAR_STYLE_FILL_SOLID_COLOR: 'doc_ppt-sidebar-style-fill-solid-color',
    DOC_PPT_SIDEBAR_STYLE_FILL_SOLID_CUSTOM_COLOR: 'doc_ppt-sidebar-style-fill-solid-custom-color',
    DOC_PPT_SIDEBAR_STYLE_FILL_GRADIENT_TYPE: 'doc_ppt-sidebar-style-fill-gradient-type',
    DOC_PPT_SIDEBAR_STYLE_FILL_GRADIENT_ANGLE: 'doc_ppt-sidebar-style-fill-gradient-angle',
    DOC_PPT_SIDEBAR_STYLE_FILL_GRADIENT_POS: 'doc_ppt-sidebar-style-fill-gradient-pos',
    DOC_PPT_SIDEBAR_STYLE_FILL_GRADIENT_ADD_COLOR: 'doc_ppt-sidebar-style-fill-gradient-add-color',
    DOC_PPT_SIDEBAR_STYLE_FILL_GRADIENT_DE_COLOR: 'doc_ppt-sidebar-style-fill-gradient-de-color',
    DOC_PPT_SIDEBAR_STYLE_FILL_GRADIENT_RE_COLOR: 'doc_ppt-sidebar-style-fill-gradient-re-color',
    DOC_PPT_SIDEBAR_STYLE_FILL_GRADIENT_EDIT_COLOR: 'doc_ppt-sidebar-style-fill-gradient-edit-color',
    DOC_PPT_SIDEBAR_STYLE_FILL_GRADIENT_ROTATE: 'doc_ppt-sidebar-style-fill-gradient-rotate',
    DOC_PPT_SIDEBAR_STYLE_FILL_PIC_UPLOAD: 'doc_ppt-sidebar-style-fill-pic-upload',
    DOC_PPT_SIDEBAR_STYLE_FILL_PIC_PASTE: 'doc_ppt-sidebar-style-fill-pic-paste',
    DOC_PPT_SIDEBAR_STYLE_FILL_PIC_TYPE: 'doc_ppt-sidebar-style-fill-pic-type',
    DOC_PPT_SIDEBAR_STYLE_FILL_PIC_TRANS: 'doc_ppt-sidebar-style-fill-pic-trans',
    DOC_PPT_SIDEBAR_STYLE_FILL_PIC_ROTATE: 'doc_ppt-sidebar-style-fill-pic-rotate',
    DOC_PPT_SIDEBAR_STYLE_BORDER_SHORTCUT: 'doc_ppt-sidebar-style-border-shortcut',
    DOC_PPT_SIDEBAR_STYLE_BORDER_TYPE: 'doc_ppt-sidebar-style-border-type',
    DOC_PPT_SIDEBAR_STYLE_BORDER_SOLID_TYPE: 'doc_ppt-sidebar-style-border-solid-type',
    DOC_PPT_SIDEBAR_STYLE_BORDER_SOLID_SIZE: 'doc_ppt-sidebar-style-border-solid-size',
    DOC_PPT_SIDEBAR_STYLE_BORDER_SOLID_COLOR: 'doc_ppt-sidebar-style-border-solid-color',
    DOC_PPT_SIDEBAR_STYLE_BORDER_SOLID_CUSTOM_COLOR: 'doc_ppt-sidebar-style-border-solid-custom-color',
    DOC_PPT_SIDEBAR_STYLE_BORDER_POINT: 'doc_ppt-sidebar-style-border-point',
    DOC_PPT_SIDEBAR_STYLE_BORDER_SOLID_TRANS: 'doc_ppt-sidebar-style-border-solid-trans',
    DOC_PPT_SIDEBAR_STYLE_BORDER_GRADIENT_TYPE: 'doc_ppt-sidebar-style-border-gradient-type',
    DOC_PPT_SIDEBAR_STYLE_BORDER_GRADIENT_ANGLE: 'doc_ppt-sidebar-style-border-gradient-angle',
    DOC_PPT_SIDEBAR_STYLE_BORDER_GRADIENT_POS: 'doc_ppt-sidebar-style-border-gradient-pos',
    DOC_PPT_SIDEBAR_STYLE_BORDER_GRADIENT_ADD_COLOR: 'doc_ppt-sidebar-style-border-gradient-add-color',
    DOC_PPT_SIDEBAR_STYLE_BORDER_GRADIENT_DE_COLOR: 'doc_ppt-sidebar-style-border-gradient-de-color',
    DOC_PPT_SIDEBAR_STYLE_BORDER_GRADIENT_RE_COLOR: 'doc_ppt-sidebar-style-border-gradient-re-color',
    DOC_PPT_SIDEBAR_STYLE_BORDER_GRADIENT_EDIT_COLOR: 'doc_ppt-sidebar-style-border-gradient-edit-color',
    DOC_PPT_SIDEBAR_STYLE_BORDER_GRADIENT_TRANS: 'doc_ppt-sidebar-style-border-gradient-trans',
    DOC_PPT_SIDEBAR_STYLE_SHADOW_SHORTCUT: 'doc_ppt-sidebar-style-shadow-shortcut',
    DOC_PPT_SIDEBAR_STYLE_SHADOW_SIZE: 'doc_ppt-sidebar-style-shadow-size',
    DOC_PPT_SIDEBAR_STYLE_SHADOW_BLUR: 'doc_ppt-sidebar-style-shadow-blur',
    DOC_PPT_SIDEBAR_STYLE_SHADOW_DISTANCE: 'doc_ppt-sidebar-style-shadow-distance',
    DOC_PPT_SIDEBAR_STYLE_SHADOW_TRANS: 'doc_ppt-sidebar-style-shadow-trans',
    DOC_PPT_SIDEBAR_STYLE_SHADOW_ANGLE: 'doc_ppt-sidebar-style-shadow-angle',
    DOC_PPT_SIDEBAR_STYLE_SHADOW_COLOR: 'doc_ppt-sidebar-style-shadow-color',
    DOC_PPT_SIDEBAR_STYLE_SHADOW_CUSTOM_COLOR: 'doc_ppt-sidebar-style-shadow-custom-color',
    DOC_PPT_SIDEBAR_STYLE_GLOW_SHORTCUT: 'doc_ppt-sidebar-style-glow-shortcut',
    DOC_PPT_SIDEBAR_STYLE_GLOW_SIZE: 'doc_ppt-sidebar-style-glow-size',
    DOC_PPT_SIDEBAR_STYLE_GLOW_BLUR: 'doc_ppt-sidebar-style-glow-blur',
    DOC_PPT_SIDEBAR_STYLE_GLOW_DISTANCE: 'doc_ppt-sidebar-style-glow-distance',
    DOC_PPT_SIDEBAR_STYLE_GLOW_TRANS: 'doc_ppt-sidebar-style-glow-trans',
    DOC_PPT_SIDEBAR_STYLE_LUMINE_SHORTCUT: 'doc_ppt-sidebar-style-lumine-shortcut',
    DOC_PPT_SIDEBAR_STYLE_LUMINE_SIZE: 'doc_ppt-sidebar-style-lumine-size',
    DOC_PPT_SIDEBAR_STYLE_LUMINE_TRANS: 'doc_ppt-sidebar-style-lumine-trans',
    DOC_PPT_SIDEBAR_STYLE_LUMINE_COLOR: 'doc_ppt-sidebar-style-lumine-color',
    DOC_PPT_SIDEBAR_STYLE_LUMINE_CUSTOM_COLOR: 'doc_ppt-sidebar-style-lumine-custom-color',
    DOC_PPT_SIDEBAR_STYLE_SOFTEN_SHORTCUT: 'doc_ppt-sidebar-style-soften-shortcut',
    DOC_PPT_SIDEBAR_STYLE_SOFTEN_SIZE: 'doc_ppt-sidebar-style-soften-size',
    DOC_PPT_SIDEBAR_STYLE_TRANS_TRANS: 'doc_ppt-sidebar-style-trans-trans',
    DOC_PPT_SIDEBAR_TEXT_FONT_FONT: 'doc_ppt-sidebar-text-font-font',
    DOC_PPT_SIDEBAR_TEXT_FONT_COLOR: 'doc_ppt-sidebar-text-font-color',
    DOC_PPT_SIDEBAR_TEXT_FONT_CUSTOM_COLOR: 'doc_ppt-sidebar-text-font-custom-color',
    DOC_PPT_SIDEBAR_TEXT_FONT_SIZE: 'doc_ppt-sidebar-text-font-size',
    DOC_PPT_SIDEBAR_TEXT_FONT_INCREASE_SIZE: 'doc_ppt-sidebar-text-font-increase-size',
    DOC_PPT_SIDEBAR_TEXT_FONT_DECREASE_SIZE: 'doc_ppt-sidebar-text-font-decrease-size',
    DOC_PPT_SIDEBAR_TEXT_FONT_HIGHLIGHT: 'doc_ppt-sidebar-text-font-highlight',
    DOC_PPT_SIDEBAR_TEXT_FONT_BOLD: 'doc_ppt-sidebar-text-font-bold',
    DOC_PPT_SIDEBAR_TEXT_FONT_ITALIC: 'doc_ppt-sidebar-text-font-italic',
    DOC_PPT_SIDEBAR_TEXT_FONT_UNDERLINE: 'doc_ppt-sidebar-text-font-underline',
    DOC_PPT_SIDEBAR_TEXT_FONT_SUBSCRIPT: 'doc_ppt-sidebar-text-font-subscript',
    DOC_PPT_SIDEBAR_TEXT_FONT_SUPERSCRIPT: 'doc_ppt-sidebar-text-font-superscript',
    DOC_PPT_SIDEBAR_TEXT_FONT_STRIKE: 'doc_ppt-sidebar-text-font-strike',
    DOC_PPT_SIDEBAR_TEXT_PARAGRAPH_H_ALIGN: 'doc_ppt-sidebar-text-paragraph-h-align',
    DOC_PPT_SIDEBAR_TEXT_PARAGRAPH_V_ALIGN: 'doc_ppt-sidebar-text-paragraph-v-align',
    DOC_PPT_SIDEBAR_TEXT_PARAGRAPH_INDENT: 'doc_ppt-sidebar-text-paragraph-indent',
    DOC_PPT_SIDEBAR_TEXT_PARAGRAPH_BULLETS: 'doc_ppt-sidebar-text-paragraph-bullets',
    DOC_PPT_SIDEBAR_TEXT_PARAGRAPH_NUMBERING: 'doc_ppt-sidebar-text-paragraph-numbering',
    DOC_PPT_SIDEBAR_TEXT_PARAGRAPH_LINE_SPACING: 'doc_ppt-sidebar-text-paragraph-line-spacing',
    DOC_PPT_SIDEBAR_TEXT_BOX_AUTO_ADJUST: 'doc_ppt-sidebar-text-box-auto-adjust',
    DOC_PPT_SIDEBAR_TEXT_BOX_DIRECTION: 'doc_ppt-sidebar-text-box-direction',
    DOC_PPT_SIDEBAR_TEXT_BOX_PADDING: 'doc_ppt-sidebar-text-box-padding',
    DOC_PPT_SIDEBAR_TEXT_BOX_AUTO_WRAP: 'doc_ppt-sidebar-text-box-auto-wrap',
    DOC_PPT_SIDEBAR_LAYOUT_ALIGN_H_ALIGN: 'doc_ppt-sidebar-layout-align-h-align',
    DOC_PPT_SIDEBAR_LAYOUT_ALIGN_V_ALIGN: 'doc_ppt-sidebar-layout-align-v-align',
    DOC_PPT_SIDEBAR_LAYOUT_ALIGN_DISTRIBUTE: 'doc_ppt-sidebar-layout-align-distribute',
    DOC_PPT_SIDEBAR_LAYOUT_LEVEL_ALL: 'doc_ppt-sidebar-layout-level-all',
    DOC_PPT_SIDEBAR_LAYOUT_LEVEL_ADJUST: 'doc_ppt-sidebar-layout-level-adjust',
    DOC_PPT_SIDEBAR_LAYOUT_GROUP_GROUP: 'doc_ppt-sidebar-layout-group-group',
    DOC_PPT_SIDEBAR_LAYOUT_SIZE_SIZE: 'doc_ppt-sidebar-layout-size-size',
    DOC_PPT_SIDEBAR_LAYOUT_SIZE_LOCK_RATE: 'doc_ppt-sidebar-layout-size-lock-rate',
    DOC_PPT_SIDEBAR_LAYOUT_ROTATE_ROTATE: 'doc_ppt-sidebar-layout-rotate-rotate',
    DOC_PPT_SIDEBAR_TABLE_BORDER_TYPE: 'doc_ppt-sidebar-table-border-type',
    DOC_PPT_SIDEBAR_TABLE_BORDER_COLOR: 'doc_ppt-sidebar-table-border-color',
    DOC_PPT_SIDEBAR_TABLE_BORDER_CUSTOM_COLOR: 'doc_ppt-sidebar-table-border-custom-color',
    DOC_PPT_SIDEBAR_PICTURE_EDIT_CROP: 'doc_ppt-sidebar-picture-edit-crop',
    DOC_PPT_SIDEBAR_PICTURE_EDIT_TRANS: 'doc_ppt-sidebar-picture-edit-trans',
    DOC_PPT_SIDEBAR_PICTURE_CORRECTION_RESET: 'doc_ppt-sidebar-picture-correction-reset',
    DOC_PPT_SIDEBAR_PICTURE_CORRECTION_CLARITY: 'doc_ppt-sidebar-picture-correction-clarity',
    DOC_PPT_SIDEBAR_PICTURE_CORRECTION_BRIGHTNESS: 'doc_ppt-sidebar-picture-correction-brightness',
    DOC_PPT_SIDEBAR_PICTURE_CORRECTION_CONTRAST: 'doc_ppt-sidebar-picture-correction-contrast',
    DOC_PPT_SIDEBAR_PICTURE_EFFECT_RESET: 'doc_ppt-sidebar-picture-effect-reset',
    DOC_PPT_SIDEBAR_PICTURE_EFFECT_SATURATION: 'doc_ppt-sidebar-picture-effect-saturation',
    DOC_PPT_SIDEBAR_PICTURE_EFFECT_TEMPERATURE: 'doc_ppt-sidebar-picture-effect-temperature',
    DOC_PPT_SIDEBAR_BACKGROUND_RESET: 'doc_ppt-sidebar-background-reset',
    DOC_PPT_SIDEBAR_BACKGROUND_APPLY_ALL: 'doc_ppt-sidebar-background-apply-all',
    DOC_PPT_SIDEBAR_STYLE_FILL_SOLID_TRANS: 'doc_ppt-sidebar-style-fill-solid-trans',
    DOC_PPT_SIDEBAR_STYLE_FILL_GRADIENT_TRANS: 'doc_ppt-sidebar-style-fill-gradient-trans',
    OCR_DOC_PICTURE_ENTRANCE: 'OCR-doc_picture-entrance',
    DOC_PPT_SIDEBAR_LAYOUT_SIZE_ZOOM: 'doc_ppt-sidebar-layout-size-zoom',
    DOC_PPT_SIDEBAR_LAYOUT_POS_POS: 'doc_ppt-sidebar-layout-pos-pos',
    DOC_PPT_SIDEBAR_LAYOUT_SIZE_PIC_RESIZE: 'doc_ppt-sidebar-layout-size-pic_resize',
    DOC_PPT_SIDEBAR_LAYOUT_SIZE_PIC_SIZE_ORIGINAL: 'doc_ppt-sidebar-layout-size-pic_size_original',
    // 侧边栏文本填充
    DOC_PPT_SIDEBAR_FONT_FILL_SHORTCUT: 'doc_ppt-sidebar-text-fill-shortcut',
    DOC_PPT_SIDEBAR_FONT_FILL_SET: 'doc_ppt-sidebar-text-fill-set',
    DOC_PPT_SIDEBAR_FONT_FILL_SOLID_COLOR: 'doc_ppt-sidebar-text-fill-solid-color',
    DOC_PPT_SIDEBAR_FONT_FILL_SOLID_CUSTOM_COLOR: 'doc_ppt-sidebar-text-fill-solid-custom-color',
    DOC_PPT_SIDEBAR_FONT_FILL_SOLID_TRANS: 'doc_ppt-sidebar-text-fill-solid-trans',
    DOC_PPT_SIDEBAR_FONT_FILL_GRADIENT_TYPE: 'doc_ppt-sidebar-text-fill-gradient-type',
    DOC_PPT_SIDEBAR_FONT_FILL_GRADIENT_ANGLE: 'doc_ppt-sidebar-text-fill-gradient-angle',
    DOC_PPT_SIDEBAR_FONT_FILL_GRADIENT_POS: 'doc_ppt-sidebar-text-fill-gradient-pos',
    DOC_PPT_SIDEBAR_FONT_FILL_GRADIENT_ADD_COLOR: 'doc_ppt-sidebar-text-fill-gradient-add-color',
    DOC_PPT_SIDEBAR_FONT_FILL_GRADIENT_DE_COLOR: 'doc_ppt-sidebar-text-fill-gradient-de-color',
    DOC_PPT_SIDEBAR_FONT_FILL_GRADIENT_RE_COLOR: 'doc_ppt-sidebar-text-fill-gradient-re-color',
    DOC_PPT_SIDEBAR_FONT_FILL_GRADIENT_EDIT_COLOR: 'doc_ppt-sidebar-text-fill-gradient-edit-color',
    DOC_PPT_SIDEBAR_FONT_FILL_GRADIENT_TRANS: 'doc_ppt-sidebar-text-fill-gradient-trans',
    DOC_PPT_SIDEBAR_FONT_FILL_PIC_PASTE: 'doc_ppt-sidebar-text-fill-pic-paste',
    DOC_PPT_SIDEBAR_FONT_FILL_PIC_UPLOAD: 'doc_ppt-sidebar-text-fill-pic-upload',
    DOC_PPT_SIDEBAR_FONT_FILL_PIC_TYPE: 'doc_ppt-sidebar-text-fill-pic-type',
    DOC_PPT_SIDEBAR_FONT_FILL_PIC_TRANS: 'doc_ppt-sidebar-text-fill-pic-trans',
    // 侧边栏文本边框
    DOC_PPT_SIDEBAR_FONT_BORDER_SHORTCUT: 'doc_ppt-sidebar-text-border-shortcut',
    DOC_PPT_SIDEBAR_FONT_BORDER_SOLID_TYPE: 'doc_ppt-sidebar-text-border-solid-type',
    DOC_PPT_SIDEBAR_FONT_BORDER_TYPE: 'doc_ppt-sidebar-text-border-type',
    DOC_PPT_SIDEBAR_FONT_BORDER_SOLID_SIZE: 'doc_ppt-sidebar-text-border-solid-size',
    DOC_PPT_SIDEBAR_FONT_BORDER_SOLID_COLOR: 'doc_ppt-sidebar-text-border-solid-color',
    DOC_PPT_SIDEBAR_FONT_BORDER_SOLID_CUSTOM_COLOR: 'doc_ppt-sidebar-text-border-solid-custom-color',
    DOC_PPT_SIDEBAR_FONT_BORDER_SOLID_TRANS: 'doc_ppt-sidebar-text-border-solid-trans',
    DOC_PPT_SIDEBAR_FONT_BORDER_GRADIENT_TYPE: 'doc_ppt-sidebar-text-border-gradient-type',
    DOC_PPT_SIDEBAR_FONT_BORDER_GRADIENT_ANGLE: 'doc_ppt-sidebar-text-border-gradient-angle',
    DOC_PPT_SIDEBAR_FONT_BORDER_GRADIENT_POS: 'doc_ppt-sidebar-text-border-gradient-pos',
    DOC_PPT_SIDEBAR_FONT_BORDER_GRADIENT_ADD_COLOR: 'doc_ppt-sidebar-text-border-gradient-add-color',
    DOC_PPT_SIDEBAR_FONT_BORDER_GRADIENT_DE_COLOR: 'doc_ppt-sidebar-text-border-gradient-de-color',
    DOC_PPT_SIDEBAR_FONT_BORDER_GRADIENT_RE_COLOR: 'doc_ppt-sidebar-text-border-gradient-re-color',
    DOC_PPT_SIDEBAR_FONT_BORDER_GRADIENT_EDIT_COLOR: 'doc_ppt-sidebar-text-border-gradient-edit-color',
    DOC_PPT_SIDEBAR_FONT_BORDER_GRADIENT_TRANS: 'doc_ppt-sidebar-text-border-gradient-trans',
    // 侧边栏文本效果
    DOC_PPT_SIDEBAR_FONT_SHADOW_SHORTCUT: 'doc_ppt-sidebar-text-shadow-shortcut',
    DOC_PPT_SIDEBAR_FONT_SHADOW_SIZE: 'doc_ppt-sidebar-text-shadow-size',
    DOC_PPT_SIDEBAR_FONT_SHADOW_BLUR: 'doc_ppt-sidebar-text-shadow-blur',
    DOC_PPT_SIDEBAR_FONT_SHADOW_DISTANCE: 'doc_ppt-sidebar-text-shadow-distance',
    DOC_PPT_SIDEBAR_FONT_SHADOW_TRANS: 'doc_ppt-sidebar-text-shadow-trans',
    DOC_PPT_SIDEBAR_FONT_SHADOW_ANGLE: 'doc_ppt-sidebar-text-shadow-angle',
    DOC_PPT_SIDEBAR_FONT_SHADOW_COLOR: 'doc_ppt-sidebar-text-shadow-color',
    DOC_PPT_SIDEBAR_FONT_SHADOW_CUSTOM_COLOR: 'doc_ppt-sidebar-text-shadow-custom-color',
    DOC_PPT_SIDEBAR_FONT_GLOW_SHORTCUT: 'doc_ppt-sidebar-text-glow-shortcut',
    DOC_PPT_SIDEBAR_FONT_GLOW_SIZE: 'doc_ppt-sidebar-text-glow-size',
    DOC_PPT_SIDEBAR_FONT_GLOW_BLUR: 'doc_ppt-sidebar-text-glow-blur',
    DOC_PPT_SIDEBAR_FONT_GLOW_DISTANCE: 'doc_ppt-sidebar-text-glow-distance',
    DOC_PPT_SIDEBAR_FONT_GLOW_TRANS: 'doc_ppt-sidebar-text-glow-trans',
    DOC_PPT_SIDEBAR_FONT_LUMINE_SHORTCUT: 'doc_ppt-sidebar-text-lumine-shortcut',
    DOC_PPT_SIDEBAR_FONT_LUMINE_SIZE: 'doc_ppt-sidebar-text-lumine-size',
    DOC_PPT_SIDEBAR_FONT_LUMINE_TRANS: 'doc_ppt-sidebar-text-lumine-trans',
    DOC_PPT_SIDEBAR_FONT_LUMINE_COLOR: 'doc_ppt-sidebar-text-lumine-color',
    DOC_PPT_SIDEBAR_FONT_LUMINE_CUSTOM_COLOR: 'doc_ppt-sidebar-text-lumine-custom-color',
    // 新动画面板
    DOC_PPT_SIDEBAR_ANIME_ADD_ANIME: 'doc_ppt-sidebar_anime-add_anime',
    DOC_PPT_SIDEBAR_ANIME_DELETE_ANIME: 'doc_ppt-sidebar_anime-delete_anime',
    DOC_PPT_SIDEBAR_ANIME_PLAY_ANIME: 'doc_ppt-sidebar_anime-play_anime',
    DOC_PPT_SIDEBAR_ANIME_PLAY_ALL: 'doc_ppt-sidebar_anime-play_all',
    DOC_PPT_SIDEBAR_ANIME_DRAG: 'doc_ppt-sidebar_anime-drag',
    DOC_PPT_SIDEBAR_ANIME_SWITCH_ANIME: 'doc_ppt-sidebar_anime-switch_anime',
    DOC_PPT_SIDEBAR_ANIME_SET_START_WAY: 'doc_ppt-sidebar_anime-set_start_way',
    DOC_PPT_SIDEBAR_ANIME_SET_DIRECTION: 'doc_ppt-sidebar_anime-set_direction',
    DOC_PPT_SIDEBAR_ANIME_SET_DELAY: 'doc_ppt-sidebar_anime-set_delay',
    DOC_PPT_SIDEBAR_ANIME_SET_DURATION: 'doc_ppt-sidebar_anime-set_duration',
    DOC_PPT_SIDEBAR_ANIME_SET_TIRGGER: 'doc_ppt-sidebar_anime-set_tirgger',
    DOC_PPT_SIDEBAR_ANIME_SET_PROPERTY: 'doc_ppt-sidebar_anime-set_property',
    // 新选择窗格
    DOC_PPT_SELECT_PANEL_OPEN: 'doc_ppt-select_panel-open',
    DOC_PPT_SELECT_PANEL_SHOW_ALL: 'doc_ppt-select_panel-show_all',
    DOC_PPT_SELECT_PANEL_HIDE_ALL: 'doc_ppt-select_panel-hide_all',
    DOC_PPT_SELECT_PANEL_HIDE_ONE: 'doc_ppt-select_panel-hide_one',
    DOC_PPT_SELECT_PANEL_SHOW_ONE: 'doc_ppt-select_panel-show_one',
    DOC_PPT_SELECT_PANEL_UNFOLD_GROUP: 'doc_ppt-select_panel-unfold_group',
    DOC_PPT_SELECT_PANEL_FOLD_GROUP: 'doc_ppt-select_panel-fold_group',
    DOC_PPT_SELECT_PANEL_DRAG: 'doc_ppt-select_panel-drag',
    DOC_PPT_SELECT_PANEL_SET_WIDTH: 'doc_ppt-select_panel-set_width',

    // 新色盘
    COLOR_PICKER_EVENT_CODE: 'doc_ppt-color_palette-color',

    // 新工具栏
    DOC_PPT_S_MENU_CLK: 'doc_ppt-s_menu-clk', // PPT桌面端-单栏菜单-按钮点击
    DOC_PPT_TOOLBAR_INSERT_TAB_CLK: 'doc_ppt-toolbar_insert_tab-clk', // PPT桌面端-插入tab-点击
    DOC_PPT_TOOLBAR_INSERT_TAB_PAGE: 'doc_ppt-toolbar_insert_tab-page', // PPT桌面端-插入tab-空白页面
    DOC_PPT_TOOLBAR_INSERT_TAB_TEMPLATE: 'doc_ppt-toolbar_insert_tab-template', // PPT桌面端-插入tab-模版页面
    DOC_PPT_TOOLBAR_INSERT_TAB_TEXT_BOX: 'doc_ppt-toolbar_insert_tab-text_box', // PPT桌面端-插入tab-文本框
    DOC_PPT_TOOLBAR_INSERT_TAB_SHAPES: 'doc_ppt-toolbar_insert_tab-shapes', // PPT桌面端-插入tab-形状
    DOC_PPT_TOOLBAR_INSERT_TAB_PICTURES: 'doc_ppt-toolbar_insert_tab-pictures', // PPT桌面端-插入tab-图片
    DOC_PPT_TOOLBAR_INSERT_TAB_TABLE: 'doc_ppt-toolbar_insert_tab-table', // PPT桌面端-插入tab-表格
    DOC_PPT_TOOLBAR_INSERT_TAB_LINK: 'doc_ppt-toolbar_insert_tab-link', // PPT桌面端-插入tab-链接
    DOC_PPT_TOOLBAR_INSERT_TAB_LATEX: 'doc_ppt-toolbar_insert_tab-latex', // PPT桌面端-插入tab-公式
    DOC_PPT_TOOLBAR_INSERT_TAB_CHART: 'doc_ppt-toolbar_insert_tab-chart', // PPT桌面端-插入tab-图表
    DOC_PPT_TOOLBAR_INSERT_TAB_FOOTER: 'doc_ppt-toolbar_insert_tab-footer', // PPT桌面端-插入tab-页脚
    DOC_PPT_TOOLBAR_INSERT_TAB_TDOCS: 'doc_ppt-toolbar_insert_tab-tdocs', // PPT桌面端-插入tab-腾讯文档
    DOC_PPT_TOOLBAR_INSERT_TAB_FILES: 'doc_ppt-toolbar_insert_tab-files', // PPT桌面端-插入tab-本地文件
    DOC_PPT_TOOLBAR_INSERT_TAB_ADDON: 'doc_ppt-toolbar_insert_tab-addon', // PPT桌面端-插入tab-第三方内容
    DOC_PPT_TOOLBAR_EFFICIENT_TAB_CLK: 'doc_ppt-toolbar_efficient_tab-clk', // PPT桌面端-效率工具tab-点击
    DOC_PPT_TOOLBAR_EFFICIENT_TAB_SANITIZE: 'doc_ppt-toolbar_efficient_tab-sanitize', // PPT桌面端-效率工具tab-数据脱敏
    DOC_PPT_TOOLBAR_EFFICIENT_TAB_DOWNLOAD_PIC: 'doc_ppt-toolbar_efficient_tab-download_pic', // PPT桌面端-效率工具tab-图片下载
    DOC_PPT_TOOLBAR_EFFICIENT_TAB_CONVERT_PDF: 'doc_ppt-toolbar_efficient_tab-convert_pdf', // PPT桌面端-效率工具tab-pdf转换
    DOC_PPT_TOOLBAR_EFFICIENT_TAB_CREATE_PIC: 'doc_ppt-toolbar_efficient_tab-create_pic', // PPT桌面端-效率工具tab-生成图片
    DOC_PPT_TOOLBAR_EFFICIENT_TAB_ADDON: 'doc_ppt-toolbar_efficient_tab-addon', // PPT桌面端-效率工具tab-插件
    DOC_PPT_TOOLBAR_PLAY_TAB_CLK: 'doc_ppt-toolbar_play_tab-clk', // PPT桌面端-放映tab-点击
    DOC_PPT_TOOLBAR_PLAY_TAB_BEGIN: 'doc_ppt-toolbar_play_tab-begin', // PPT桌面端-放映tab-从头演示
    DOC_PPT_TOOLBAR_PLAY_TAB_CURRENT: 'doc_ppt-toolbar_play_tab-current', // PPT桌面端-放映tab-从当前页演示
    DOC_PPT_TOOLBAR_PLAY_TAB_NOTE_VIEW: 'doc_ppt-toolbar_play_tab-note_view', // PPT桌面端-放映tab-备注视图
    DOC_PPT_TOOLBAR_PLAY_TAB_REMOTE: 'doc_ppt-toolbar_play_tab-remote', // PPT桌面端-放映tab-远程演示
    DOC_PPT_TOOLBAR_PLAY_TAB_TMEETING: 'doc_ppt-toolbar_play_tab-tmeeting', // PPT桌面端-放映tab-腾讯会议演示
    DOC_PPT_ANIMATION_TAB_CLK: 'doc_ppt-animation_tab-clk', // PPT桌面端-动画tab-点击
    DOC_PPT_ANIMATION_TAB_BATCH: 'doc_ppt-animation_batch', // PPT桌面端-批量动画-入口点击
    DOC_PPT_ANIMATION_BATCH_ORDER_CLK: 'doc_ppt-animation_batch_order-clk', // PPT桌面端-批量动画-指令点击
    DOC_PPT_ANIMATION_BATCH_CANCEL: 'doc_ppt-animation_batch_cancel', // PPT桌面端-批量动画-取消添加
    DOC_PPT_ANIMATION_BATCH_SUCCESS: 'doc_ppt-animation_batch_success', // PPT桌面端-动画tab-添加成功
    DOC_PPT_ANIMATION_BATCH_ADD: 'doc_ppt-animation_batch_add', // PPT桌面端-批量动画-批量添加动画
    DOC_PPT_ANIMATION_BATCH_TOOLBAR_DELETE: 'doc_ppt-animation_batch_toolbar_delete', // PPT桌面端-批量动画-工具栏删除动画
    DOC_PPT_ANIMATION_BATCH_ADD_SUCCESS: 'doc_ppt-animation_batch_add_success', // PPT桌面端-批量动画-添加成功
    DOC_PPT_ANIMATION_BATCH_DELETE_MORE: 'doc_ppt-animation_batch_delete_more', // PPT桌面端-批量动画-更多删除选项
    DOC_PPT_ANIMATION_BATCH_DELETE_MORE_SUCCESS: 'doc_ppt-animation_batch_delete_more_success', // PPT桌面端-批量动画-更多删除成功
    DOC_PPT_BEAUTIFY_TAB_CLK: 'doc_ppt-beautify_tab-clk', // PPT桌面端-美化tab-点击
    DOC_PPT_START_TAB_CLK: 'doc_ppt-start_tab-clk', // PPT桌面端-动画tab-点击
    DOC_PPT_TOOLBAR_VIEW_TAB_CLK: 'doc_ppt-toolbar_view_tab-clk',
    DOC_PPT_TOOLBAR_VIEW_TAB_NORMAL: 'doc_ppt-toolbar_view_tab-normal',
    DOC_PPT_TOOLBAR_VIEW_TAB_MASTER: 'doc_ppt-toolbar_view_tab-master',
    DOC_PPT_TOOLBAR_VIEW_TAB_RULER: 'doc_ppt-toolbar_view_tab-ruler',
    DOC_PPT_TOOLBAR_VIEW_TAB_GUIDES: 'doc_ppt-toolbar_view_tab-guides',
    DOC_PPT_TOOLBAR_VIEW_TAB_GRIDLINE: 'doc_ppt-toolbar_view_tab-gridline',
    DOC_PPT_TOOLBAR_VIEW_TAB_SNAP_LINE: 'doc_ppt-toolbar_view_tab-snap_line',
    DOC_PPT_TOOLBAR_VIEW_TAB_NOTE: 'doc_ppt-toolbar_view_tab-note',
    DOC_PPT_TOOLBAR_VIEW_TAB_ZOOM: 'doc_ppt-toolbar_view_tab-zoom',
    DOC_PPT_TOOLBAR_VIEW_TAB_AUTO_ZOOM: 'doc_ppt-toolbar_view_tab-auto_zoom',
    DOC_PPT_TOOLBAR_VIEW_TAB_CORNER_MARK: 'doc_ppt-toolbar_view_tab-corner_mark',
    DOC_PPT_REVIEW_TAB_CLK: 'doc_ppt-review_tab-clk',
    DOC_PPT_REVIEW_TAB_ADD_COMMENTS: 'doc_ppt-review_tab-add_comments',
    DOC_PPT_REVIEW_TAB_DELETE_COMMENTS: 'doc_ppt-review_tab-delete_comments',
    DOC_PPT_REVIEW_TAB_DELETE_PAGE_COMMENTS: 'doc_ppt-review_tab-delete_page_comments',
    DOC_PPT_REVIEW_TAB_DELETE_ALL_COMMENTS: 'doc_ppt-review_tab-delete_all_comments',
    DOC_PPT_REVIEW_TAB_LAST_COMMENTS: 'doc_ppt-review_tab-last_comments',
    DOC_PPT_REVIEW_TAB_NEXT_COMMENTS: 'doc_ppt-review_tab-next_comments',
    DOC_PPT_REVIEW_TAB_VIEW_COMMENTS: 'doc_ppt-review_tab-view_comments',
    DOC_PPT_REVIEW_TAB_SHOW_COMMENTS_MARKS: 'doc_ppt-review_tab-show_comments_marks',
    DOC_PPT_REVIEW_TAB_NEW_COMMENTS_REMIND: 'doc_ppt-review_tab-new_comments_remind',
    DOC_PPT_COMMENTS_MARK_CLK: 'doc_ppt-comments-mark_clk',
    DOC_PPT_COMMENTS_REMIND_VIEW: 'doc_ppt-comments-remind_view',
    DOC_PPT_COMMENTS_REMIND_CLK: 'doc_ppt-comments-remind_clk',
    DOC_PPT_COMMENTS_ADD_COMMENTS: 'doc_ppt-comments-add_comments',
    DOC_PPT_COMMENTS_ADD_COMMENTS_SUCCESS: 'doc_ppt-comments-add_comments_success',
    DOC_PPT_COMMENTS_SLIDEBAR_OPEN: 'doc_ppt-comments_slidebar-open',
    DOC_PPT_COMMENTS_SLIDEBAR_CLOSE: 'doc_ppt-comments_slidebar-close',
    DOC_PPT_COMMENTS_SLIDEBAR_LAST_COMMENT: 'doc_ppt-comments_slidebar-last_comment',
    DOC_PPT_COMMENTS_SLIDEBAR_NEXT_COMMENT: 'doc_ppt-comments_slidebar-next_comment',
    DOC_PPT_COMMENTS_SLIDEBAR_REPLY: 'doc_ppt-comments_slidebar-reply',
    DOC_PPT_COMMENTS_SLIDEBAR_EDIT_CMMENTS: 'doc_ppt-comments_slidebar-edit_cmments',
    DOC_PPT_COMMENTS_SLIDEBAR_EDIT_REPLY: 'doc_ppt-comments_slidebar-edit_reply',
    DOC_PPT_COMMENTS_SLIDEBAR_DELETE_REPLY: 'doc_ppt-comments_slidebar-delete_reply',
    DOC_PPT_COMMENTS_SLIDEBAR_DELETE_COMMENTS: 'doc_ppt-comments_slidebar-delete_comments',
};


export const EventPosition = {
    PC_RIGHT_MENU: 'pc_rightmenu',
    PC_TOOLBAR: 'pc_toolbar',
};
